import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Ruler, Building, FileText, Download, Share2, Eye, Heart, Calendar, Users, Edit, ChevronLeft, ChevronRight, Palette, Layout, Image, TrendingUp, Store, HandshakeIcon, Loader2, Target, Lightbulb, AlertCircle, CheckCircle, Info, Mail, X, Leaf, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
const mockPropertyData = {
  id: 1,
  address: 'Via Montenapoleone 12, Milano',
  price: 850000,
  size: 120,
  type: 'Retail',
  status: 'Disponibile',
  zone: 'Centro',
  floor: 'Piano Terra',
  description: "Prestigioso locale commerciale situato nel cuore del quadrilatero della moda milanese. Posizione strategica con grande visibilità e passaggio pedonale elevato. Ideale per brand di lusso e boutique di alta gamma. L'immobile si presenta in ottime condizioni con finiture di pregio, ampie vetrine e soffitti alti.",
  features: ['Vetrine su strada', 'Aria condizionata', 'Sistema antifurto', 'Magazzino', 'Bagno', 'Certificazione energetica A'],
  views: 45,
  interested: 8,
  availability: 'Immediata',
  mainImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg',
  gallery: ['https://uploadthingy.s3.us-west-1.amazonaws.com/4YkAY7UqKQUPpQ92yzEMgw/681b7f504e32f.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/gggVNqt7oMzSPTA1GSg7hs/a0230d7093e3a80e46b36f3aff623d30.webp', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHDvCsUGQXrnWCVhpb6AR9/5-allestimento-punti-vendita-roma.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/daux6xG8NsQHUpRzjpKkfj/Screenshot_2025-11-05_alle_13.25.38.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nApHqCsLnhTw7aP1mFPzUT/Rodeo-Drive-Negozi.jpg'],
  planimetria: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800',
  mappa: 'https://uploadthingy.s3.us-west-1.amazonaws.com/daux6xG8NsQHUpRzjpKkfj/Screenshot_2025-11-05_alle_13.25.38.png',
  superficie: {
    pianoTerra: 128,
    pianoInterrato: 160,
    pianoAmmezzato: 141
  },
  vetrine: 4,
  contratto: {
    tipo: 'Nuovo contratto di locazione 6+6 anni',
    categoria: 'Grandi locazioni'
  },
  canone: 600000,
  agencyFee: ["15% sul valore del canone di locazione e/o fitto di ramo d'azienda", '3% sul valore pagato a titolo di cessione e/o indennità', "3% dell'importo in caso di vendita"]
};
const mockStreetData = {
  streetName: 'Via Montenapoleone',
  trafficLevel: 'Molto Alto',
  trafficScore: 95,
  pedestrianFlow: '15.000+ persone/giorno',
  brandPresence: [{
    name: 'Gucci',
    category: 'Fashion Luxury',
    distance: '50m'
  }, {
    name: 'Prada',
    category: 'Fashion Luxury',
    distance: '80m'
  }, {
    name: 'Louis Vuitton',
    category: 'Fashion Luxury',
    distance: '120m'
  }, {
    name: 'Hermès',
    category: 'Fashion Luxury',
    distance: '150m'
  }, {
    name: 'Cartier',
    category: 'Jewelry',
    distance: '180m'
  }],
  analysis: {
    positioning: 'Eccellente',
    visibility: 'Massima',
    competition: 'Alta (vantaggiosa)',
    targetAudience: 'Luxury High-End',
    recommendation: 'Location ideale per brand di lusso. La presenza di marchi prestigiosi nella via aumenta il valore percepito e attrae clientela di alto profilo.'
  }
};
const mockTrattative = [{
  id: 1,
  brand: 'Luxury Fashion Brand',
  category: 'Fashion',
  stage: 'Trattativa',
  startDate: '15/01/2024',
  lastUpdate: '18/01/2024',
  budget: '800k-1M',
  contact: 'Marco Rossi',
  notes: 'Molto interessati, richiedono sopralluogo'
}, {
  id: 2,
  brand: 'Premium Lifestyle Co.',
  category: 'Lifestyle',
  stage: 'Proposta',
  startDate: '12/01/2024',
  lastUpdate: '16/01/2024',
  budget: '750k-900k',
  contact: 'Laura Bianchi',
  notes: 'In attesa di approvazione budget'
}, {
  id: 3,
  brand: 'Elite Fashion Group',
  category: 'Fashion',
  stage: 'Interesse',
  startDate: '08/01/2024',
  lastUpdate: '14/01/2024',
  budget: '850k-1.2M',
  contact: 'Giuseppe Verdi',
  notes: 'Prima visita programmata'
}, {
  id: 4,
  brand: 'Maison de Luxe Paris',
  category: 'Fashion',
  stage: 'Trattativa',
  startDate: '20/12/2023',
  lastUpdate: '17/01/2024',
  budget: '900k-1.1M',
  contact: 'Sophie Laurent',
  notes: 'Negoziazione in corso sul canone, molto interessati alla location'
}, {
  id: 5,
  brand: 'Urban Style Collective',
  category: 'Streetwear',
  stage: 'Interesse',
  startDate: '05/01/2024',
  lastUpdate: '12/01/2024',
  budget: '700k-850k',
  contact: 'Andrea Ferrari',
  notes: 'Richiedono modifiche agli spazi interni'
}, {
  id: 6,
  brand: 'Heritage Luxury House',
  category: 'Fashion',
  stage: 'Chiusa',
  startDate: '10/11/2023',
  lastUpdate: '28/12/2023',
  budget: '800k-950k',
  contact: 'Maria Conti',
  notes: 'Trattativa conclusa - hanno optato per altra location'
}, {
  id: 7,
  brand: 'Contemporary Design Studio',
  category: 'Lifestyle',
  stage: 'Proposta',
  startDate: '18/01/2024',
  lastUpdate: '19/01/2024',
  budget: '750k-900k',
  contact: 'Luca Romano',
  notes: 'Proposta inviata, in attesa di feedback dalla direzione'
}, {
  id: 8,
  brand: 'Atelier Milano',
  category: 'Fashion',
  stage: 'Trattativa',
  startDate: '02/01/2024',
  lastUpdate: '15/01/2024',
  budget: '850k-1M',
  contact: 'Francesca Moretti',
  notes: 'Secondo sopralluogo completato, valutazione architetto in corso'
}, {
  id: 9,
  brand: 'Global Retail Group',
  category: 'Retail',
  stage: 'Interesse',
  startDate: '22/12/2023',
  lastUpdate: '10/01/2024',
  budget: '700k-800k',
  contact: 'Thomas Weber',
  notes: 'Interesse preliminare, richiedono documentazione aggiuntiva'
}, {
  id: 10,
  brand: 'Boutique Exclusive Paris',
  category: 'Fashion',
  stage: 'Proposta',
  startDate: '28/12/2023',
  lastUpdate: '16/01/2024',
  budget: '900k-1.2M',
  contact: 'Claire Dubois',
  notes: 'Proposta economica in revisione, molto interessati al progetto'
}, {
  id: 11,
  brand: 'Luxury Accessories House',
  category: 'Accessories',
  stage: 'Interesse',
  startDate: '15/01/2024',
  lastUpdate: '17/01/2024',
  budget: '650k-800k',
  contact: 'Paolo Greco',
  notes: 'Primo contatto, richiedono visita della location'
}, {
  id: 12,
  brand: 'Premium Sportswear Brand',
  category: 'Sportswear',
  stage: 'Chiusa',
  startDate: '05/12/2023',
  lastUpdate: '20/12/2023',
  budget: '750k-900k',
  contact: 'Elena Ricci',
  notes: 'Trattativa chiusa - budget non allineato con richieste'
}, {
  id: 13,
  brand: 'Designer Collective Milano',
  category: 'Fashion',
  stage: 'Trattativa',
  startDate: '10/01/2024',
  lastUpdate: '18/01/2024',
  budget: '800k-950k',
  contact: 'Matteo Colombo',
  notes: 'Trattativa avanzata, prevista firma preliminare settimana prossima'
}];
const stageColors: Record<string, string> = {
  Trattativa: 'bg-blue-100 text-blue-800',
  Proposta: 'bg-yellow-100 text-yellow-800',
  Interesse: 'bg-green-100 text-green-800',
  Chiusa: 'bg-gray-100 text-gray-800'
};
const stores = [
// Left side of the street (top)
{
  name: 'Whole Foods',
  number: '200',
  x: 50,
  y: 80,
  width: 120,
  height: 80,
  category: 'food',
  side: 'left'
}, {
  name: 'Gucci',
  number: '203',
  x: 190,
  y: 80,
  width: 100,
  height: 80,
  category: 'luxury',
  side: 'left'
}, {
  name: 'Prada',
  number: '205',
  x: 310,
  y: 80,
  width: 100,
  height: 80,
  category: 'luxury',
  side: 'left'
}, {
  name: 'Hermès',
  number: '209',
  x: 430,
  y: 80,
  width: 100,
  height: 80,
  category: 'luxury',
  side: 'left'
}, {
  name: 'Property',
  number: '217',
  x: 550,
  y: 80,
  width: 120,
  height: 80,
  category: 'target',
  side: 'left',
  isTarget: true
}, {
  name: 'Louis Vuitton',
  number: '211',
  x: 690,
  y: 80,
  width: 120,
  height: 80,
  category: 'luxury',
  side: 'left'
}, {
  name: 'Cartier',
  number: '221',
  x: 830,
  y: 80,
  width: 100,
  height: 80,
  category: 'luxury',
  side: 'left'
},
// Right side of the street (bottom)
{
  name: 'kate spade',
  number: '123',
  x: 50,
  y: 290,
  width: 100,
  height: 80,
  category: 'fashion',
  side: 'right'
}, {
  name: 'Panera Bread',
  number: '141',
  x: 170,
  y: 290,
  width: 110,
  height: 80,
  category: 'food',
  side: 'right'
}, {
  name: 'Chipotle',
  number: '100',
  x: 300,
  y: 290,
  width: 90,
  height: 80,
  category: 'food',
  side: 'right'
}, {
  name: 'Rite Aid',
  number: '505',
  x: 410,
  y: 290,
  width: 100,
  height: 80,
  category: 'services',
  side: 'right'
}, {
  name: "Kohl's",
  number: '500',
  x: 530,
  y: 290,
  width: 140,
  height: 80,
  category: 'retail',
  side: 'right'
}, {
  name: 'Barnes & Noble',
  number: '300',
  x: 690,
  y: 290,
  width: 120,
  height: 80,
  category: 'retail',
  side: 'right'
}, {
  name: 'Talbots',
  number: '330',
  x: 830,
  y: 290,
  width: 100,
  height: 80,
  category: 'fashion',
  side: 'right'
}];
const categories = {
  luxury: {
    color: '#DDA15E',
    label: 'Luxury Fashion'
  },
  fashion: {
    color: '#F4A460',
    label: 'Fashion & Apparel'
  },
  retail: {
    color: '#90EE90',
    label: 'Retail'
  },
  food: {
    color: '#FFB6C1',
    label: 'Restaurants + Food'
  },
  services: {
    color: '#87CEEB',
    label: 'Services'
  },
  target: {
    color: '#1388ad',
    label: 'Target Property'
  }
};
const mockHistoricalData = {
  similarProperties: [{
    id: 1,
    address: 'Via Montenapoleone 8, Milano',
    size: 115,
    zone: 'Quadrilatero',
    price: 820000,
    type: 'Retail',
    dealsClosed: 3,
    avgDaysToClose: 45,
    successRate: 88,
    finalPrice: 850000,
    topAgent: 'Marco Rossi'
  }, {
    id: 2,
    address: 'Via della Spiga 15, Milano',
    size: 125,
    zone: 'Quadrilatero',
    price: 900000,
    type: 'Boutique',
    dealsClosed: 2,
    avgDaysToClose: 52,
    successRate: 85,
    finalPrice: 920000,
    topAgent: 'Laura Bianchi'
  }, {
    id: 3,
    address: 'Corso Venezia 20, Milano',
    size: 110,
    zone: 'Centro',
    price: 780000,
    type: 'Retail',
    dealsClosed: 4,
    avgDaysToClose: 38,
    successRate: 92,
    finalPrice: 800000,
    topAgent: 'Marco Rossi'
  }],
  performanceMetrics: {
    avgSuccessRate: 88,
    avgDaysToClose: 45,
    totalDealsInZone: 28,
    avgPriceVariation: '+3.2%'
  },
  topPerformers: [{
    name: 'Marco Rossi',
    role: 'Senior Agent',
    dealsInCategory: 12,
    successRate: 85,
    avgDaysToClose: 42,
    specialization: 'Luxury Retail',
    totalValue: '€12.5M'
  }, {
    name: 'Laura Bianchi',
    role: 'Senior Agent',
    dealsInCategory: 10,
    successRate: 82,
    avgDaysToClose: 48,
    specialization: 'Fashion Brands',
    totalValue: '€10.8M'
  }, {
    name: 'Giuseppe Verdi',
    role: 'Agent',
    dealsInCategory: 8,
    successRate: 78,
    avgDaysToClose: 55,
    specialization: 'Lifestyle Brands',
    totalValue: '€8.2M'
  }],
  brandCategories: [{
    category: 'Fashion Luxury',
    deals: 15,
    successRate: 90,
    avgBudget: '€950K'
  }, {
    category: 'Lifestyle Premium',
    deals: 8,
    successRate: 85,
    avgBudget: '€820K'
  }, {
    category: 'Jewelry',
    deals: 5,
    successRate: 88,
    avgBudget: '€1.1M'
  }]
};
const FloorPlanVisualization = () => {
  return <div className="w-full h-full bg-white" data-id="element-2104">
      <svg width="800" height="600" viewBox="0 0 800 600" className="max-w-full max-h-full bg-white" data-id="element-2105">
        {/* Background */}
        <rect x="0" y="0" width="800" height="600" fill="white" data-id="element-2106" />
        {/* Main retail space */}
        <rect x="100" y="100" width="600" height="400" fill="white" stroke="#6b7280" strokeWidth="3" data-id="element-2107" />
        {/* Interior walls */}
        {/* Back room / storage */}
        <line x1="500" y1="100" x2="500" y2="300" stroke="#6b7280" strokeWidth="3" data-id="element-2108" />
        <line x1="500" y1="300" x2="700" y2="300" stroke="#6b7280" strokeWidth="3" data-id="element-2109" />
        {/* Bathroom wall */}
        <line x1="500" y1="300" x2="500" y2="400" stroke="#6b7280" strokeWidth="3" data-id="element-2110" />
        <line x1="500" y1="400" x2="600" y2="400" stroke="#6b7280" strokeWidth="3" data-id="element-2111" />
        {/* Main entrance door */}
        <g data-id="element-2112">
          <path d="M 250 500 Q 250 480 270 480" fill="none" stroke="#9ca3af" strokeWidth="2" data-id="element-2113" />
          <line x1="250" y1="500" x2="270" y2="480" stroke="#4b5563" strokeWidth="2" data-id="element-2114" />
        </g>
        {/* Storage room door */}
        <g data-id="element-2115">
          <path d="M 500 200 Q 520 200 520 220" fill="none" stroke="#9ca3af" strokeWidth="2" data-id="element-2116" />
          <line x1="500" y1="200" x2="520" y2="220" stroke="#4b5563" strokeWidth="2" data-id="element-2117" />
        </g>
        {/* Bathroom door */}
        <g data-id="element-2118">
          <path d="M 500 350 Q 520 350 520 370" fill="none" stroke="#9ca3af" strokeWidth="2" data-id="element-2119" />
          <line x1="500" y1="350" x2="520" y2="370" stroke="#4b5563" strokeWidth="2" data-id="element-2120" />
        </g>
        {/* Windows - front */}
        <rect x="350" y="97" width="100" height="6" fill="white" stroke="#1388ad" strokeWidth="3" data-id="element-2121" />
        <line x1="350" y1="100" x2="450" y2="100" stroke="#1388ad" strokeWidth="1" strokeDasharray="5,5" data-id="element-2122" />
        <rect x="120" y="200" width="6" height="120" fill="white" stroke="#1388ad" strokeWidth="3" data-id="element-2123" />
        <line x1="123" y1="200" x2="123" y2="320" stroke="#1388ad" strokeWidth="1" strokeDasharray="5,5" data-id="element-2124" />
        {/* Measurements */}
        {/* Width measurement */}
        <g data-id="element-2125">
          <line x1="100" y1="520" x2="700" y2="520" stroke="#6b7280" strokeWidth="1" strokeDasharray="5,5" data-id="element-2126" />
          <line x1="100" y1="515" x2="100" y2="525" stroke="#6b7280" strokeWidth="2" data-id="element-2127" />
          <line x1="700" y1="515" x2="700" y2="525" stroke="#6b7280" strokeWidth="2" data-id="element-2128" />
          <text x="400" y="545" textAnchor="middle" fontSize="14" fill="#4b5563" fontWeight="600" data-id="element-2129">
            12.00 m
          </text>
        </g>
        {/* Height measurement */}
        <g data-id="element-2130">
          <line x1="720" y1="100" x2="720" y2="500" stroke="#6b7280" strokeWidth="1" strokeDasharray="5,5" data-id="element-2131" />
          <line x1="715" y1="100" x2="725" y2="100" stroke="#6b7280" strokeWidth="2" data-id="element-2132" />
          <line x1="715" y1="500" x2="725" y2="500" stroke="#6b7280" strokeWidth="2" data-id="element-2133" />
          <text x="750" y="305" textAnchor="middle" fontSize="14" fill="#4b5563" fontWeight="600" transform="rotate(90 750 305)" data-id="element-2134">
            10.00 m
          </text>
        </g>
        {/* Room labels */}
        <text x="300" y="280" textAnchor="middle" fontSize="20" fill="#1f2937" fontWeight="700" data-id="element-2135">
          AREA VENDITA
        </text>
        <text x="300" y="310" textAnchor="middle" fontSize="14" fill="#6b7280" data-id="element-2136">
          85 m²
        </text>
        <text x="600" y="200" textAnchor="middle" fontSize="16" fill="#1f2937" fontWeight="600" data-id="element-2137">
          MAGAZZINO
        </text>
        <text x="600" y="225" textAnchor="middle" fontSize="12" fill="#6b7280" data-id="element-2138">
          25 m²
        </text>
        <text x="600" y="350" textAnchor="middle" fontSize="16" fill="#1f2937" fontWeight="600" data-id="element-2139">
          BAGNO
        </text>
        <text x="600" y="375" textAnchor="middle" fontSize="12" fill="#6b7280" data-id="element-2140">
          10 m²
        </text>
        {/* Legend */}
        <g transform="translate(50, 30)" data-id="element-2141">
          <text x="0" y="0" fontSize="12" fontWeight="700" fill="#1f2937" data-id="element-2142">
            LEGENDA:
          </text>
          <line x1="0" y1="15" x2="30" y2="15" stroke="#6b7280" strokeWidth="3" data-id="element-2143" />
          <text x="35" y="20" fontSize="11" fill="#4b5563" data-id="element-2144">
            Muro
          </text>
          <rect x="0" y="30" width="30" height="6" fill="white" stroke="#1388ad" strokeWidth="3" data-id="element-2145" />
          <text x="35" y="38" fontSize="11" fill="#4b5563" data-id="element-2146">
            Vetrina
          </text>
          <path d="M 0 50 Q 0 45 5 45" fill="none" stroke="#9ca3af" strokeWidth="2" data-id="element-2147" />
          <line x1="0" y1="50" x2="5" y2="45" stroke="#4b5563" strokeWidth="2" data-id="element-2148" />
          <text x="35" y="52" fontSize="11" fill="#4b5563" data-id="element-2149">
            Porta
          </text>
        </g>
        {/* North arrow */}
        <g transform="translate(730, 50)" data-id="element-2150">
          <circle cx="0" cy="0" r="20" fill="white" stroke="#6b7280" strokeWidth="2" data-id="element-2151" />
          <path d="M 0 -15 L 5 5 L 0 0 L -5 5 Z" fill="#1388ad" data-id="element-2152" />
          <text x="0" y="8" textAnchor="middle" fontSize="10" fontWeight="700" fill="#1f2937" data-id="element-2153">
            N
          </text>
        </g>
        {/* Title block */}
        <g transform="translate(50, 550)" data-id="element-2154">
          <rect x="0" y="0" width="250" height="40" fill="white" stroke="#6b7280" strokeWidth="2" data-id="element-2155" />
          <text x="10" y="18" fontSize="12" fontWeight="700" fill="#1f2937" data-id="element-2156">
            Via Montenapoleone 12, Milano
          </text>
          <text x="10" y="33" fontSize="10" fill="#6b7280" data-id="element-2157">
            Scala 1:50 | Superficie: 120 m²
          </text>
        </g>
      </svg>
    </div>;
};
const StreetMapVisualization = () => {
  return <div className="w-full space-y-4" data-id="element-2158">
      <div className="mb-4" data-id="element-2159">
        <h4 className="text-sm font-semibold text-gray-900" data-id="element-2160">
          Mappa Via Montenapoleone
        </h4>
        <p className="text-xs text-gray-500 mt-1" data-id="element-2161">
          Vista della strada con negozi su entrambi i lati
        </p>
      </div>
      <div className="overflow-x-auto" data-id="element-2162">
        <svg width="1200" height="450" viewBox="0 0 1200 450" style={{
        maxWidth: '100%'
      }} className="border border-gray-200 rounded-lg" data-id="element-2163">
          {/* Background */}
          <rect x="0" y="0" width="1200" height="450" fill="white" data-id="element-2164" />
          {/* Sidewalk - top */}
          <rect x="30" y="60" width="940" height="110" fill="transparent" rx="4" data-id="element-2165" />
          {/* Street/Road */}
          <rect x="30" y="180" width="940" height="90" fill="white" stroke="#dee2e6" strokeWidth="2" rx="4" data-id="element-2166" />
          {/* Road markings */}
          <line x1="30" y1="225" x2="970" y2="225" stroke="#fff" strokeWidth="2" strokeDasharray="20,15" opacity="0.5" data-id="element-2167" />
          {/* Sidewalk - bottom */}
          <rect x="30" y="280" width="940" height="110" fill="transparent" rx="4" data-id="element-2168" />
          {/* Direction arrows on street */}
          <g opacity="0.3" data-id="element-2169">
            <path d="M 200 215 L 200 235 M 190 225 L 200 215 L 210 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2170" />
            <path d="M 500 215 L 500 235 M 490 225 L 500 215 L 510 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2171" />
            <path d="M 800 215 L 800 235 M 790 225 L 800 215 L 810 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2172" />
          </g>
          {/* Stores */}
          {stores.map((store, idx) => {
          const category = categories[store.category as keyof typeof categories];
          return <g key={idx} data-id="element-2173">
                {/* Store rectangle */}
                <rect x={store.x} y={store.y} width={store.width} height={store.height} fill={category.color} stroke={store.isTarget ? '#1388ad' : '#495057'} strokeWidth={store.isTarget ? '4' : '2'} rx="4" data-id="element-2174" />
                {/* Store number badge */}
                <rect x={store.x + 5} y={store.y + 5} width="35" height="18" fill="white" stroke="#495057" strokeWidth="1" rx="3" data-id="element-2175" />
                <text x={store.x + 22.5} y={store.y + 17} textAnchor="middle" fontSize="10" fontWeight="700" fill="#495057" data-id="element-2176">
                  {store.number}
                </text>
                {/* Store name */}
                <text x={store.x + store.width / 2} y={store.y + store.height / 2 + 5} textAnchor="middle" fontSize={store.isTarget ? '13' : '11'} fontWeight={store.isTarget ? '700' : '600'} fill={store.isTarget ? 'white' : '#212529'} data-id="element-2177">
                  {store.name.split('\n').map((line, i) => <tspan key={i} x={store.x + store.width / 2} dy={i > 0 ? '12' : '0'} data-id="element-2178">
                      {line}
                    </tspan>)}
                </text>
                {/* Target property indicator */}
                {store.isTarget && <>
                    <text x={store.x + store.width / 2} y={store.y - 12} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1388ad" data-id="element-2179">
                      ★ IMMOBILE TARGET ★
                    </text>
                  </>}
              </g>;
        })}
          {/* Street side labels */}
          <text x="15" y="125" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 125)" data-id="element-2180">
            LATO NORD
          </text>
          <text x="15" y="335" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 335)" data-id="element-2181">
            LATO SUD
          </text>
          {/* Legend - positioned on the right */}
          <g transform="translate(1000, 80)" data-id="element-2182">
            <text x="0" y="0" fontSize="11" fontWeight="700" fill="#212529" data-id="element-2183">
              LEGENDA
            </text>
            {Object.entries(categories).map(([key, cat], idx) => <g key={key} transform={`translate(0, ${idx * 35 + 20})`} data-id="element-2184">
                <rect x="0" y="-9" width="18" height="13" fill={cat.color} stroke="#495057" strokeWidth="1" rx="2" data-id="element-2185" />
                <text x="23" y="0" fontSize="9" fill="#495057" data-id="element-2186">
                  {cat.label}
                </text>
              </g>)}
          </g>
        </svg>
      </div>
      <div className="grid grid-cols-3 gap-4" data-id="element-2187">
        <div className="p-4 bg-[#1388ad]/10 border border-[#1388ad]/20 rounded-lg" data-id="element-2188">
          <div className="flex items-center gap-2 mb-2" data-id="element-2189">
            <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2190" />
            <span className="text-sm font-semibold text-gray-900" data-id="element-2191">
              Traffico
            </span>
          </div>
          <p className="text-2xl font-bold text-[#1388ad] mb-1" data-id="element-2192">
            {mockStreetData.trafficScore}/100
          </p>
          <p className="text-xs text-gray-600" data-id="element-2193">{mockStreetData.trafficLevel}</p>
        </div>
        <div className="p-4 bg-gray-50 rounded-lg" data-id="element-2194">
          <div className="flex items-center gap-2 mb-2" data-id="element-2195">
            <Users className="w-5 h-5 text-gray-600" data-id="element-2196" />
            <span className="text-sm font-semibold text-gray-900" data-id="element-2197">
              Flusso Pedonale
            </span>
          </div>
          <p className="text-lg font-bold text-gray-900" data-id="element-2198">
            {mockStreetData.pedestrianFlow}
          </p>
        </div>
        <div className="p-4 bg-gray-50 rounded-lg" data-id="element-2199">
          <div className="flex items-center gap-2 mb-2" data-id="element-2200">
            <Store className="w-5 h-5 text-gray-600" data-id="element-2201" />
            <span className="text-sm font-semibold text-gray-900" data-id="element-2202">
              Brand Vicini
            </span>
          </div>
          <p className="text-lg font-bold text-gray-900" data-id="element-2203">
            {mockStreetData.brandPresence.length}
          </p>
        </div>
      </div>
      <div data-id="element-2204">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2205">
          Brand Presenti nella Via
        </h3>
        <div className="space-y-3" data-id="element-2206">
          {mockStreetData.brandPresence.map((brand, idx) => <div key={idx} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2207">
              <div className="flex items-center gap-3" data-id="element-2208">
                <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center" data-id="element-2209">
                  <Store className="w-5 h-5 text-[#1388ad]" data-id="element-2210" />
                </div>
                <div data-id="element-2211">
                  <p className="text-sm font-semibold text-gray-900" data-id="element-2212">
                    {brand.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-2213">{brand.category}</p>
                </div>
              </div>
              <span className="text-sm text-gray-600" data-id="element-2214">{brand.distance}</span>
            </div>)}
        </div>
      </div>
    </div>;
};
const mockEcoScoreData = {
  overallScore: 85,
  scoreLevel: 'Eccellente',
  categories: [{
    name: 'Efficienza Energetica',
    score: 90,
    icon: '⚡'
  }, {
    name: 'Gestione Risorse',
    score: 82,
    icon: '💧'
  }, {
    name: 'Materiali Sostenibili',
    score: 78,
    icon: '🌱'
  }, {
    name: 'Qualità Aria Interna',
    score: 88,
    icon: '🌬️'
  }],
  parameters: [{
    category: 'Certificazioni',
    items: ['Certificazione Energetica Classe A', 'LEED Gold Certified', 'BREEAM Excellent']
  }, {
    category: 'Efficienza Energetica',
    items: ['Pannelli solari fotovoltaici (50 kW)', 'Sistema di illuminazione LED', 'Isolamento termico ad alte prestazioni', 'Finestre a triplo vetro basso-emissive', 'Sistema HVAC ad alta efficienza']
  }, {
    category: 'Gestione Risorse',
    items: ['Sistema di raccolta acqua piovana', 'Riduttori di flusso su tutti i rubinetti', 'WC a basso consumo idrico', 'Sistema di irrigazione intelligente']
  }, {
    category: 'Materiali e Costruzione',
    items: ['Materiali riciclati al 40%', 'Legno certificato FSC', 'Vernici a basso VOC', 'Pavimentazione sostenibile']
  }, {
    category: 'Qualità Ambientale',
    items: ['Sistema di ventilazione meccanica controllata', 'Monitoraggio qualità aria in tempo reale', 'Illuminazione naturale ottimizzata', 'Controllo acustico avanzato']
  }],
  economicImpact: {
    energySavings: '35%',
    waterSavings: '40%',
    maintenanceReduction: '25%',
    valueIncrease: '15-20%',
    annualSavings: 12000
  },
  certifications: [{
    name: 'LEED Gold',
    year: 2023,
    description: 'Leadership in Energy and Environmental Design'
  }, {
    name: 'Certificazione Energetica A',
    year: 2023,
    description: 'Massima efficienza energetica'
  }]
};
const mockAIAnalysis = `
**Potenziale dell'Immobile:**
L'immobile in Via Montenapoleone 12 rappresenta un'opportunità eccezionale nel cuore del quadrilatero della moda milanese. La posizione strategica, con un traffico pedonale superiore a 15.000 persone al giorno e la presenza di brand luxury di primo livello nelle immediate vicinanze, garantisce una visibilità e un prestigio unici. La superficie di 120 m² è ideale per concept store o flagship store di brand premium. Il prezzo di €850.000 è competitivo considerando la location e le potenzialità di fatturato.
**Profilo del Brand Ideale:**
Il brand ideale per questo spazio è un marchio di moda luxury o lifestyle premium con forte identità e posizionamento high-end. Deve avere una clientela internazionale e capacità di investimento per allestimenti di prestigio. Perfetto per brand che vogliono consolidare la presenza nel mercato italiano o lanciare nuove linee esclusive. La location richiede un brand con forte appeal visivo e capacità di attrarre clientela affluent.
**Brand Suggeriti da Contattare:**
- Bottega Veneta: Brand luxury italiano in forte espansione retail, perfetto match per location prestigiosa nel quadrilatero. Cerca attivamente nuovi spazi per concept store innovativi. Budget elevato (€800k-1.2M) allineato con il canone richiesto. Filosofia di retail esperienziale si adatta perfettamente alla superficie e alle caratteristiche dello spazio.
- Loewe: Marchio spagnolo di lusso in crescita esponenziale, con forte interesse a rafforzare presenza a Milano. Stile distintivo e clientela internazionale garantiscono traffico qualificato. Budget €750k-1M compatibile. Recente apertura store a Roma dimostra commitment sul mercato italiano.
- Brunello Cucinelli: Brand italiano di cashmere luxury con filosofia di retail esperienziale unica. Cerca location esclusive nel quadrilatero per flagship store. Budget molto elevato (€900k-1.5M) superiore al canone. Target clientela perfettamente allineato con posizionamento Via Montenapoleone. Valori del brand (artigianalità, eccellenza) coerenti con prestigio della location.
- Loro Piana: Marchio di eccellenza italiana in fase di espansione retail dopo acquisizione LVMH. Target ultra-luxury perfettamente allineato. Budget €850k-1.2M ideale per il canone richiesto. Superficie 120m² ottimale per il loro formato retail. Presenza brand vicini (Hermès, Gucci) crea sinergia perfetta.
- Ami Paris: Brand francese contemporary luxury in forte crescita, cerca location premium per primi flagship store italiani. Target giovane luxury (25-40 anni) con alto potere d'acquisto. Budget €700k-900k leggermente sotto canone ma negoziabile. Forte presenza social media garantisce visibilità e traffico. Metratura ideale per il loro concept retail.
- Jacquemus: Marchio francese innovativo e di tendenza, con forte appeal mediatico. Cerca location iconiche per store europei. Budget €650k-850k ai limiti inferiori ma brand in rapida crescita. Forte presenza Instagram (5M+ followers) garantisce visibilità immediata. Stile minimale e distintivo si adatta perfettamente allo spazio.
- The Row: Brand luxury minimale americano delle sorelle Olsen. Ricerca location esclusive per boutique europee. Budget €800k-1M allineato. Clientela ultra-high-end perfettamente in target. Filosofia retail discreta ma di altissimo livello. Presenza limitata in Italia rappresenta opportunità unica.
**Strategie di Marketing Consigliate:**
- Organizzare eventi esclusivi per buyer e decision maker dei brand target durante Fashion Week
- Creare un dossier premium con analisi dettagliata del traffico e demographics della via
- Proporre periodo di prova o pop-up store per testare la location
- Evidenziare i case study di successo dei brand vicini
- Offrire servizio di consulenza per allestimento e visual merchandising
- Creare partnership con Milano Fashion Week per visibilità
**Punti di Forza:**
- Location prestigiosa nel cuore del quadrilatero della moda
- Traffico pedonale eccezionale (15.000+ persone/giorno)
- Presenza di brand luxury di riferimento nelle immediate vicinanze
- Vetrine ampie con massima visibilità sulla strada
- Superficie ideale per concept store (120 m²)
- Certificazione energetica A e ottime condizioni generali
- Disponibilità immediata per apertura rapida
**Criticità:**
- Prezzo di affitto elevato richiede brand con fatturato importante
- Alta competizione con altri spazi premium nella zona
- Necessità di investimento significativo per allestimento luxury
- Aspettative elevate in termini di brand positioning
- Contratti tipicamente lunghi (6-9 anni) richiesti per location premium
`;
export function PropertyDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'info' | 'gallery' | 'planimetria' | 'streetmap' | 'ecoscore' | 'trattative'>('info');
  const [viewMode, setViewMode] = useState<'info' | 'scheda' | 'analisi-ai'>('info');
  const [currentPage, setCurrentPage] = useState(0);
  const [schedaLayout, setSchedaLayout] = useState('modern');
  const [showStreetMapModal, setShowStreetMapModal] = useState(false);
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [showZoomModal, setShowZoomModal] = useState(false);
  const [campaignStep, setCampaignStep] = useState<'loading' | 'brands' | 'schedule'>('loading');
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);
  const [campaignDate, setCampaignDate] = useState('');
  const [campaignTime, setCampaignTime] = useState('');
  const [aiAnalysisLoading, setAiAnalysisLoading] = useState(false);
  const [selectorStyle, setSelectorStyle] = useState({
    left: 0,
    width: 0
  });
  const buttonRefs = useRef<{
    [key: string]: HTMLButtonElement | null;
  }>({});
  // Fixed color for scheda immobile
  const schedaColor = '#1388ad';
  // Slide-specific settings
  const [slideSettings, setSlideSettings] = useState({
    0: {
      showPrice: true,
      layout: 'overlay'
    },
    1: {
      showImages: true,
      columns: 2
    },
    2: {
      showMeasurements: true,
      showLegend: true
    },
    3: {
      gridCols: 3
    },
    4: {
      showStats: true,
      showLegend: true
    }
  });
  const updateSlideSettings = (slideIndex: number, settings: any) => {
    setSlideSettings(prev => ({
      ...prev,
      [slideIndex]: {
        ...prev[slideIndex],
        ...settings
      }
    }));
  };
  // Calculate selector position based on active view mode
  useEffect(() => {
    const activeButton = buttonRefs.current[viewMode];
    if (activeButton) {
      const parent = activeButton.parentElement;
      if (parent) {
        const parentRect = parent.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();
        setSelectorStyle({
          left: buttonRect.left - parentRect.left,
          width: buttonRect.width
        });
      }
    }
  }, [viewMode]);
  const viewModes = [{
    id: 'info' as const,
    label: 'Informazioni',
    icon: Info
  }, {
    id: 'scheda' as const,
    label: 'Scheda Immobile',
    icon: FileText
  }, {
    id: 'analisi-ai' as const,
    label: 'Analisi AI',
    icon: TrendingUp
  }];
  useEffect(() => {
    if (viewMode === 'analisi-ai' && !aiAnalysisLoading) {
      setAiAnalysisLoading(true);
      setTimeout(() => {
        setAiAnalysisLoading(false);
      }, 3000);
    }
  }, [viewMode]);
  const tabs = [{
    id: 'info' as const,
    label: 'Informazioni',
    icon: Building
  }, {
    id: 'gallery' as const,
    label: 'Galleria',
    icon: Image
  }, {
    id: 'planimetria' as const,
    label: 'Planimetria',
    icon: FileText
  }, {
    id: 'streetmap' as const,
    label: 'StreetMap',
    icon: MapPin
  }, {
    id: 'ecoscore' as const,
    label: 'Eco Score',
    icon: Leaf
  }, {
    id: 'trattative' as const,
    label: 'Trattative',
    icon: HandshakeIcon
  }];
  const parseAIAnalysis = (content: string) => {
    // Clean markdown formatting
    const cleanContent = content.replace(/\*\*/g, '') // Remove bold markers
    .replace(/\*/g, '') // Remove italic markers
    .replace(/#{1,6}\s/g, ''); // Remove heading markers
    const sections = {
      potenziale: '',
      brandIdeale: '',
      brandSuggeriti: [] as string[],
      strategie: [] as string[],
      puntiForza: [] as string[],
      criticita: [] as string[]
    };
    const lines = cleanContent.split('\n');
    let currentSection = '';
    for (const line of lines) {
      const trimmedLine = line.trim();
      if (trimmedLine.toLowerCase().includes('potenziale') && trimmedLine.includes(':')) {
        currentSection = 'potenziale';
        continue;
      } else if (trimmedLine.toLowerCase().includes('brand ideale') || trimmedLine.toLowerCase().includes('profilo del brand')) {
        currentSection = 'brandIdeale';
        continue;
      } else if (trimmedLine.toLowerCase().includes('brand') && (trimmedLine.toLowerCase().includes('contattare') || trimmedLine.toLowerCase().includes('suggeriti'))) {
        currentSection = 'brandSuggeriti';
        continue;
      } else if (trimmedLine.toLowerCase().includes('strategie') || trimmedLine.toLowerCase().includes('marketing')) {
        currentSection = 'strategie';
        continue;
      } else if (trimmedLine.toLowerCase().includes('punti di forza') || trimmedLine.toLowerCase().includes('vantaggi')) {
        currentSection = 'puntiForza';
        continue;
      } else if (trimmedLine.toLowerCase().includes('criticità') || trimmedLine.toLowerCase().includes('svantaggi')) {
        currentSection = 'criticita';
        continue;
      }
      if (trimmedLine.startsWith('-') || trimmedLine.startsWith('•') || trimmedLine.match(/^\d+\./)) {
        const cleanLine = trimmedLine.replace(/^[-•]\s*/, '').replace(/^\d+\.\s*/, '');
        if (currentSection === 'brandSuggeriti') {
          sections.brandSuggeriti.push(cleanLine);
        } else if (currentSection === 'strategie') {
          sections.strategie.push(cleanLine);
        } else if (currentSection === 'puntiForza') {
          sections.puntiForza.push(cleanLine);
        } else if (currentSection === 'criticita') {
          sections.criticita.push(cleanLine);
        }
      } else if (trimmedLine && !trimmedLine.includes('#')) {
        if (currentSection === 'potenziale') {
          sections.potenziale += trimmedLine + ' ';
        } else if (currentSection === 'brandIdeale') {
          sections.brandIdeale += trimmedLine + ' ';
        }
      }
    }
    return sections;
  };
  const schedaPages = [{
    title: 'Copertina',
    content: <div className="relative w-full h-full bg-white flex flex-col" data-id="element-2215">
          {/* Header */}
          <div className="flex items-start justify-between p-6 border-b border-gray-200" data-id="element-2216">
            <div data-id="element-2217">
              <div className="text-3xl font-bold text-gray-700 mb-1" data-id="element-2218">
                <span className="text-gray-700" data-id="element-2219">E</span>
                <span style={{
              color: schedaColor
            }} data-id="element-2220">
                  D
                </span>
                <span className="text-gray-700" data-id="element-2221">A</span>
              </div>
              <div className="text-xs" style={{
            color: schedaColor
          }} data-id="element-2222">
                REAL ESTATE SOLUTIONS
              </div>
            </div>
            <div className="text-right text-xs text-gray-700" data-id="element-2223">
              <div data-id="element-2224">Via della Vite 7 00187, Roma</div>
              <div data-id="element-2225">066797851 | info@edares.it</div>
            </div>
          </div>
          {/* Main Image with Overlay */}
          <div className="relative flex-1" data-id="element-2226">
            <img src={mockPropertyData.mainImage} alt={mockPropertyData.address} className="absolute inset-0 w-full h-full object-cover" data-id="element-2227" />
            {/* Overlay Rectangle */}
            <div className="absolute inset-0 flex items-center justify-center" style={{
          background: `linear-gradient(to bottom, transparent 30%, ${schedaColor}40 30%, ${schedaColor}40 70%, transparent 70%)`
        }} data-id="element-2228">
              <div className="border-4 w-3/5 h-2/5" style={{
            borderColor: schedaColor
          }} data-id="element-2229"></div>
            </div>
            {/* Address Overlay */}
            <div className="absolute bottom-0 right-0 px-6 py-3 text-white text-2xl font-bold" style={{
          backgroundColor: schedaColor
        }} data-id="element-2230">
              MILANO - {mockPropertyData.address.split(',')[0]}
            </div>
          </div>
        </div>
  }, {
    title: 'Specifiche',
    content: <div className="w-full h-full bg-white flex flex-col" data-id="element-2231">
          {/* Title Banner */}
          <div className="relative px-6 py-3 text-white text-2xl font-bold" style={{
        backgroundColor: schedaColor,
        clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)'
      }} data-id="element-2232">
            SPECIFICHE
          </div>
          <div className="flex-1 grid grid-cols-2 gap-4 p-6" data-id="element-2233">
            {/* Left: Images from gallery */}
            <div className="space-y-3" data-id="element-2234">
              {mockPropertyData.gallery.slice(0, 2).map((img, idx) => <div key={idx} className="relative" data-id="element-2235">
                  <img src={img} alt={`View ${idx + 1}`} className="w-full h-48 object-cover rounded" data-id="element-2236" />
                  <div className="absolute inset-0 flex items-center justify-center" style={{
              backgroundColor: `${schedaColor}20`
            }} data-id="element-2237">
                    <div className="border-4 w-1/3 h-1/2" style={{
                borderColor: schedaColor
              }} data-id="element-2238"></div>
                  </div>
                </div>)}
            </div>
            {/* Right: Details */}
            <div className="space-y-4" data-id="element-2239">
              {/* SUPERFICIE */}
              <div data-id="element-2240">
                <h3 className="text-xl font-bold mb-2" style={{
              color: schedaColor
            }} data-id="element-2241">
                  SUPERFICIE
                </h3>
                <div className="space-y-1 text-gray-700 text-sm" data-id="element-2242">
                  <div className="flex items-center gap-2" data-id="element-2243">
                    <span data-id="element-2244">-</span>
                    <span data-id="element-2245">
                      Piano terra: {mockPropertyData.superficie.pianoTerra} mq
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2246">
                    <span data-id="element-2247">-</span>
                    <span data-id="element-2248">
                      Piano interrato:{' '}
                      {mockPropertyData.superficie.pianoInterrato} mq
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2249">
                    <span data-id="element-2250">-</span>
                    <span data-id="element-2251">
                      Piano ammezzato:{' '}
                      {mockPropertyData.superficie.pianoAmmezzato} mq
                    </span>
                  </div>
                </div>
              </div>
              {/* VETRINE */}
              <div data-id="element-2252">
                <h3 className="text-xl font-bold mb-2" style={{
              color: schedaColor
            }} data-id="element-2253">
                  VETRINE
                </h3>
                <div className="text-gray-700 text-lg" data-id="element-2254">
                  {mockPropertyData.vetrine}
                </div>
              </div>
              {/* CONTRATTO */}
              <div data-id="element-2255">
                <h3 className="text-xl font-bold mb-2" style={{
              color: schedaColor
            }} data-id="element-2256">
                  CONTRATTO
                </h3>
                <div className="text-gray-700 text-sm space-y-1" data-id="element-2257">
                  <div data-id="element-2258">{mockPropertyData.contratto.tipo}</div>
                  <div data-id="element-2259">{mockPropertyData.contratto.categoria}</div>
                </div>
              </div>
              {/* CANONE */}
              <div data-id="element-2260">
                <h3 className="text-xl font-bold mb-2" style={{
              color: schedaColor
            }} data-id="element-2261">
                  CANONE
                </h3>
                <div className="text-gray-700 text-lg" data-id="element-2262">
                  € {mockPropertyData.canone.toLocaleString()},00/anno
                </div>
              </div>
              {/* AGENCY FEE */}
              <div data-id="element-2263">
                <h3 className="text-xl font-bold mb-2" style={{
              color: schedaColor
            }} data-id="element-2264">
                  AGENCY FEE
                </h3>
                <div className="space-y-1 text-gray-700 text-xs" data-id="element-2265">
                  {mockPropertyData.agencyFee.map((fee, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-2266">
                      <span data-id="element-2267">-</span>
                      <span className="leading-tight" data-id="element-2268">{fee}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          {/* Footer Note */}
          <div className="px-6 py-3 text-[10px] text-gray-500 border-t border-gray-200" data-id="element-2269">
            <div className="italic leading-tight" data-id="element-2270">
              Documento informativo e confidenziale. Le informazioni contenute
              in questa comunicazione sono strettamente riservate. Ne è vietata
              la copia e la divulgazione.
            </div>
            <div className="italic mt-1 leading-tight" data-id="element-2271">
              I dati contenuti nella presente sono puramente indicativi e non
              costituiscono in alcun modo una valida proposta contrattuale.
            </div>
            <div className="font-semibold mt-1 leading-tight" data-id="element-2272">
              L'insegna specificata è a mero titolo esplicativo per una semplice
              individuazione della location.
            </div>
          </div>
        </div>
  }, {
    title: 'Planimetrie',
    content: <div className="w-full h-full bg-white flex flex-col p-6" data-id="element-2273">
          <div className="px-6 py-3 text-white text-xl font-bold mb-3" style={{
        backgroundColor: schedaColor,
        clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)'
      }} data-id="element-2274">
            PLANIMETRIA
          </div>
          <div className="flex-1 flex items-center justify-center overflow-hidden" data-id="element-2275">
            <div className="w-full h-full flex items-center justify-center" data-id="element-2276">
              <FloorPlanVisualization data-id="element-2277" />
            </div>
          </div>
          {/* Footer */}
          <div className="flex items-center justify-between pt-3 border-t border-gray-200 mt-3" data-id="element-2278">
            <div className="text-xs text-gray-700" data-id="element-2279">
              <div data-id="element-2280">Via della Vite 7 00187, Roma</div>
              <div data-id="element-2281">06 6797851 | info@edares.it</div>
            </div>
            <div data-id="element-2282">
              <div className="text-2xl font-bold text-gray-700" data-id="element-2283">
                <span className="text-gray-700" data-id="element-2284">E</span>
                <span style={{
              color: schedaColor
            }} data-id="element-2285">
                  D
                </span>
                <span className="text-gray-700" data-id="element-2286">A</span>
              </div>
              <div className="text-xs" style={{
            color: schedaColor
          }} data-id="element-2287">
                REAL ESTATE SOLUTIONS
              </div>
            </div>
          </div>
        </div>
  }, {
    title: 'Galleria',
    content: <div className="w-full h-full bg-white flex flex-col p-6" data-id="element-2288">
          <div className="px-6 py-3 text-white text-xl font-bold mb-3" style={{
        backgroundColor: schedaColor,
        clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)'
      }} data-id="element-2289">
            GALLERIA FOTOGRAFICA
          </div>
          <div className="flex-1 grid grid-cols-3 gap-3" data-id="element-2290">
            {mockPropertyData.gallery.map((img, idx) => <div key={idx} className="relative" data-id="element-2291">
                <img src={img} alt={`Gallery ${idx + 1}`} className="w-full h-full object-cover rounded" data-id="element-2292" />
              </div>)}
          </div>
          {/* Footer */}
          <div className="flex items-center justify-between pt-3 border-t border-gray-200 mt-3" data-id="element-2293">
            <div className="text-xs text-gray-700" data-id="element-2294">
              <div data-id="element-2295">Via della Vite 7 00187, Roma</div>
              <div data-id="element-2296">06 6797851 | info@edares.it</div>
            </div>
            <div data-id="element-2297">
              <div className="text-2xl font-bold text-gray-700" data-id="element-2298">
                <span className="text-gray-700" data-id="element-2299">E</span>
                <span style={{
              color: schedaColor
            }} data-id="element-2300">
                  D
                </span>
                <span className="text-gray-700" data-id="element-2301">A</span>
              </div>
              <div className="text-xs" style={{
            color: schedaColor
          }} data-id="element-2302">
                REAL ESTATE SOLUTIONS
              </div>
            </div>
          </div>
        </div>
  }, {
    title: 'Street Map',
    content: <div className="w-full h-full bg-white flex flex-col" data-id="element-2303">
          {/* Title Banner */}
          <div className="relative px-6 py-3 text-white text-xl font-bold" style={{
        backgroundColor: schedaColor,
        clipPath: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)'
      }} data-id="element-2304">
            STREET MAP
          </div>
          <div className="flex-1 p-4 overflow-hidden flex items-center justify-center" data-id="element-2305">
            <div className="w-full h-full flex items-center justify-center" data-id="element-2306">
              <svg width="1200" height="450" viewBox="0 0 1200 450" style={{
            maxWidth: '100%',
            maxHeight: '100%',
            height: 'auto',
            width: 'auto'
          }} className="border border-gray-200 rounded-lg" data-id="element-2307">
                {/* Background */}
                <rect x="0" y="0" width="1200" height="450" fill="white" data-id="element-2308" />
                {/* Sidewalk - top */}
                <rect x="30" y="60" width="940" height="110" fill="transparent" rx="4" data-id="element-2309" />
                {/* Street/Road */}
                <rect x="30" y="180" width="940" height="90" fill="white" stroke="#dee2e6" strokeWidth="2" rx="4" data-id="element-2310" />
                {/* Road markings */}
                <line x1="30" y1="225" x2="970" y2="225" stroke="#fff" strokeWidth="2" strokeDasharray="20,15" opacity="0.5" data-id="element-2311" />
                {/* Sidewalk - bottom */}
                <rect x="30" y="280" width="940" height="110" fill="transparent" rx="4" data-id="element-2312" />
                {/* Direction arrows on street */}
                <g opacity="0.3" data-id="element-2313">
                  <path d="M 200 215 L 200 235 M 190 225 L 200 215 L 210 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2314" />
                  <path d="M 500 215 L 500 235 M 490 225 L 500 215 L 510 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2315" />
                  <path d="M 800 215 L 800 235 M 790 225 L 800 215 L 810 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2316" />
                </g>
                {/* Stores */}
                {stores.map((store, idx) => {
              const category = categories[store.category as keyof typeof categories];
              return <g key={idx} data-id="element-2317">
                      {/* Store rectangle */}
                      <rect x={store.x} y={store.y} width={store.width} height={store.height} fill={category.color} stroke={store.isTarget ? schedaColor : '#495057'} strokeWidth={store.isTarget ? '4' : '2'} rx="4" data-id="element-2318" />
                      {/* Store number badge */}
                      <rect x={store.x + 5} y={store.y + 5} width="35" height="18" fill="white" stroke="#495057" strokeWidth="1" rx="3" data-id="element-2319" />
                      <text x={store.x + 22.5} y={store.y + 17} textAnchor="middle" fontSize="10" fontWeight="700" fill="#495057" data-id="element-2320">
                        {store.number}
                      </text>
                      {/* Store name */}
                      <text x={store.x + store.width / 2} y={store.y + store.height / 2 + 5} textAnchor="middle" fontSize={store.isTarget ? '13' : '11'} fontWeight={store.isTarget ? '700' : '600'} fill={store.isTarget ? 'white' : '#212529'} data-id="element-2321">
                        {store.name.split('\n').map((line, i) => <tspan key={i} x={store.x + store.width / 2} dy={i > 0 ? '12' : '0'} data-id="element-2322">
                            {line}
                          </tspan>)}
                      </text>
                      {/* Target property indicator */}
                      {store.isTarget && <>
                          <text x={store.x + store.width / 2} y={store.y - 12} textAnchor="middle" fontSize="11" fontWeight="700" fill={schedaColor} data-id="element-2323">
                            ★ IMMOBILE TARGET ★
                          </text>
                        </>}
                    </g>;
            })}
                {/* Street side labels */}
                <text x="15" y="125" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 125)" data-id="element-2324">
                  LATO NORD
                </text>
                <text x="15" y="335" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 335)" data-id="element-2325">
                  LATO SUD
                </text>
                {/* Legend - positioned on the right */}
                <g transform="translate(1000, 80)" data-id="element-2326">
                  <text x="0" y="0" fontSize="11" fontWeight="700" fill="#212529" data-id="element-2327">
                    LEGENDA
                  </text>
                  {Object.entries(categories).map(([key, cat], idx) => <g key={key} transform={`translate(0, ${idx * 35 + 20})`} data-id="element-2328">
                      <rect x="0" y="-9" width="18" height="13" fill={cat.color} stroke="#495057" strokeWidth="1" rx="2" data-id="element-2329" />
                      <text x="23" y="0" fontSize="9" fill="#495057" data-id="element-2330">
                        {cat.label}
                      </text>
                    </g>)}
                </g>
              </svg>
            </div>
          </div>
          {/* Footer */}
          <div className="flex items-center justify-between px-6 py-3 border-t border-gray-200" data-id="element-2331">
            <div className="text-xs text-gray-700" data-id="element-2332">
              <div data-id="element-2333">Via della Vite 7 00187, Roma</div>
              <div data-id="element-2334">06 6797851 | info@edares.it</div>
            </div>
            <div data-id="element-2335">
              <div className="text-2xl font-bold text-gray-700" data-id="element-2336">
                <span className="text-gray-700" data-id="element-2337">E</span>
                <span style={{
              color: schedaColor
            }} data-id="element-2338">
                  D
                </span>
                <span className="text-gray-700" data-id="element-2339">A</span>
              </div>
              <div className="text-xs" style={{
            color: schedaColor
          }} data-id="element-2340">
                REAL ESTATE SOLUTIONS
              </div>
            </div>
          </div>
        </div>
  }];
  const handleOpenCampaignModal = () => {
    setShowCampaignModal(true);
    setCampaignStep('loading');
    setSelectedBrands([]);
    setCampaignDate('');
    setCampaignTime('');
    // Simulate AI loading
    setTimeout(() => {
      setCampaignStep('brands');
    }, 3000);
  };
  const handleToggleBrand = (brandName: string) => {
    setSelectedBrands(prev => prev.includes(brandName) ? prev.filter(b => b !== brandName) : [...prev, brandName]);
  };
  const handleContinueToSchedule = () => {
    if (selectedBrands.length > 0) {
      setCampaignStep('schedule');
    }
  };
  const handleSendCampaign = () => {
    // Here you would actually send the campaign
    setShowCampaignModal(false);
    // Show success message or redirect
  };
  const suggestedBrands = [{
    name: 'Bottega Veneta',
    category: 'Luxury Fashion',
    match: 95
  }, {
    name: 'Loewe',
    category: 'Luxury Fashion',
    match: 92
  }, {
    name: 'Brunello Cucinelli',
    category: 'Luxury Fashion',
    match: 90
  }, {
    name: 'Loro Piana',
    category: 'Luxury Fashion',
    match: 88
  }, {
    name: 'Ami Paris',
    category: 'Contemporary Luxury',
    match: 85
  }, {
    name: 'Jacquemus',
    category: 'Contemporary Luxury',
    match: 83
  }, {
    name: 'The Row',
    category: 'Luxury Fashion',
    match: 82
  }];
  return <div className="space-y-6" data-id="element-2341">
      <div className="flex items-center justify-between" data-id="element-2342">
        <div className="space-y-4" data-id="element-2343">
          <div className="flex items-center gap-3" data-id="element-2344">
            <button onClick={() => navigate('/properties')} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2345">
              <ArrowLeft className="w-5 h-5 text-gray-600" data-id="element-2346" />
            </button>
            <div className="flex items-center gap-2 text-sm" data-id="element-2347">
              <button onClick={() => navigate('/properties')} className="text-gray-500 hover:text-gray-900 transition-colors" data-id="element-2348">
                Immobili
              </button>
              <span className="text-gray-400" data-id="element-2349">/</span>
              <span className="text-gray-900 font-medium" data-id="element-2350">
                {mockPropertyData.address.split(',')[0]}
              </span>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-2351">
            <img src={mockPropertyData.mainImage} alt={mockPropertyData.address} className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-2352" />
            <div data-id="element-2353">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2354">
                {mockPropertyData.address}
              </h1>
              <div className="flex items-center gap-2 mt-2" data-id="element-2355">
                <MapPin className="w-4 h-4 text-gray-500" data-id="element-2356" />
                <span className="text-sm text-gray-600" data-id="element-2357">
                  {mockPropertyData.zone}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-2358">
          <div className="relative flex items-center gap-2 px-1 py-1 bg-white rounded-full border border-gray-200" data-id="element-2359">
            <motion.div className="absolute bg-[#1388ad] rounded-full shadow-sm" layoutId="viewModeSelector" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} style={{
            left: selectorStyle.left,
            width: selectorStyle.width,
            top: 4,
            bottom: 4
          }} data-id="element-2360" />
            {viewModes.map(mode => {
            const Icon = mode.icon;
            return <button key={mode.id} ref={el => buttonRefs.current[mode.id] = el} onClick={() => setViewMode(mode.id)} className={`relative z-10 flex items-center gap-2 px-4 py-2 text-sm font-normal rounded-full transition-colors ${viewMode === mode.id ? 'text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-2361">
                  <Icon className="w-4 h-4" data-id="element-2362" />
                  {mode.label}
                </button>;
          })}
          </div>
        </div>
      </div>
      {viewMode === 'analisi-ai' ? aiAnalysisLoading ? <div className="bg-white border border-gray-200 rounded-lg p-12" data-id="element-2363">
            <div className="text-center space-y-6" data-id="element-2364">
              <div className="flex justify-center" data-id="element-2365">
                <div className="relative" data-id="element-2366">
                  <Loader2 className="w-16 h-16 text-[#1388ad] animate-spin" data-id="element-2367" />
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-2368">
                    <TrendingUp className="w-8 h-8 text-[#1388ad]" data-id="element-2369" />
                  </div>
                </div>
              </div>
              <div data-id="element-2370">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-2371">
                  Analisi AI in corso...
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2372">
                  Sto analizzando l'immobile e generando insights strategici
                </p>
              </div>
              <div className="space-y-2 text-left max-w-md mx-auto" data-id="element-2373">
                <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.5
          }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2374">
                  <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2375" />
                  Analisi caratteristiche immobile
                </motion.div>
                <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 1
          }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2376">
                  <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2377" />
                  Valutazione zona e traffico
                </motion.div>
                <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 1.5
          }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2378">
                  <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2379" />
                  Matching con database brand
                </motion.div>
                <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 2
          }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2380">
                  <Loader2 className="w-4 h-4 text-[#1388ad] animate-spin" data-id="element-2381" />
                  Generazione raccomandazioni...
                </motion.div>
              </div>
            </div>
          </div> : <div className="space-y-6" data-id="element-2382">
            <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-2383">
              <div className="flex items-center justify-between" data-id="element-2384">
                <div className="flex items-center gap-3" data-id="element-2385">
                  <div data-id="element-2386">
                    <h2 className="text-xl font-semibold text-gray-900" data-id="element-2387">
                      Analisi AI Immobile
                    </h2>
                    <p className="text-sm text-gray-500" data-id="element-2388">
                      Compatibilità con storico Edares e insights strategici
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Compatibility Overview */}
            <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-2389">
              <div className="flex items-start gap-3 mb-6" data-id="element-2390">
                <div className="p-2 bg-[#1388ad]/10 rounded-lg" data-id="element-2391">
                  <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2392" />
                </div>
                <div data-id="element-2393">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-2394">
                    Compatibilità con Storico Edares
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2395">
                    Analisi basata su{' '}
                    {mockHistoricalData.performanceMetrics.totalDealsInZone}{' '}
                    trattative simili chiuse
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-4 gap-4 mb-6" data-id="element-2396">
                <div className="p-4 bg-gradient-to-br from-[#1388ad]/10 to-[#1388ad]/5 border border-[#1388ad]/20 rounded-lg" data-id="element-2397">
                  <p className="text-xs text-gray-600 mb-2" data-id="element-2398">
                    Tasso Successo Medio
                  </p>
                  <p className="text-3xl font-bold text-[#1388ad]" data-id="element-2399">
                    {mockHistoricalData.performanceMetrics.avgSuccessRate}%
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2400">
                    su immobili simili
                  </p>
                </div>
                <div className="p-4 border border-gray-200 rounded-lg" data-id="element-2401">
                  <p className="text-xs text-gray-600 mb-2" data-id="element-2402">
                    Giorni Medi Chiusura
                  </p>
                  <p className="text-3xl font-bold text-gray-900" data-id="element-2403">
                    {mockHistoricalData.performanceMetrics.avgDaysToClose}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2404">tempo medio</p>
                </div>
                <div className="p-4 border border-gray-200 rounded-lg" data-id="element-2405">
                  <p className="text-xs text-gray-600 mb-2" data-id="element-2406">
                    Trattative in Zona
                  </p>
                  <p className="text-3xl font-bold text-gray-900" data-id="element-2407">
                    {mockHistoricalData.performanceMetrics.totalDealsInZone}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2408">storico completo</p>
                </div>
                <div className="p-4 border border-gray-200 rounded-lg" data-id="element-2409">
                  <p className="text-xs text-gray-600 mb-2" data-id="element-2410">
                    Variazione Prezzo
                  </p>
                  <p className="text-3xl font-bold text-green-600" data-id="element-2411">
                    {mockHistoricalData.performanceMetrics.avgPriceVariation}
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2412">
                    vs prezzo iniziale
                  </p>
                </div>
              </div>
            </div>

            {/* Similar Properties */}
            <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-2413">
              <div className="flex items-start gap-3 mb-6" data-id="element-2414">
                <div className="p-2 bg-gray-100 rounded-lg" data-id="element-2415">
                  <Building2 className="w-5 h-5 text-gray-700" data-id="element-2416" />
                </div>
                <div data-id="element-2417">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-2418">
                    Immobili Simili nello Storico
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2419">
                    Trattative chiuse con caratteristiche comparabili
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-2420">
                {mockHistoricalData.similarProperties.map(property => <div key={property.id} className="p-5 border border-gray-200 rounded-lg hover:border-[#1388ad] transition-colors" data-id="element-2421">
                    <div className="flex items-start justify-between mb-4" data-id="element-2422">
                      <div className="flex-1" data-id="element-2423">
                        <div className="flex items-center gap-3 mb-2" data-id="element-2424">
                          <h4 className="text-base font-semibold text-gray-900" data-id="element-2425">
                            {property.address}
                          </h4>
                          <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full" data-id="element-2426">
                            {property.type}
                          </span>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-gray-600" data-id="element-2427">
                          <span data-id="element-2428">{property.size}m²</span>
                          <span data-id="element-2429">•</span>
                          <span data-id="element-2430">{property.zone}</span>
                          <span data-id="element-2431">•</span>
                          <span data-id="element-2432">€{property.price.toLocaleString()}</span>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-2433">
                        <div className="flex items-center gap-2 mb-1" data-id="element-2434">
                          <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2435" />
                          <span className="text-sm font-semibold text-green-600" data-id="element-2436">
                            {property.successRate}% successo
                          </span>
                        </div>
                        <p className="text-xs text-gray-500" data-id="element-2437">
                          {property.dealsClosed} trattative chiuse
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-200" data-id="element-2438">
                      <div data-id="element-2439">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2440">
                          Giorni Chiusura
                        </p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2441">
                          {property.avgDaysToClose} giorni
                        </p>
                      </div>
                      <div data-id="element-2442">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2443">
                          Prezzo Finale
                        </p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2444">
                          €{property.finalPrice.toLocaleString()}
                        </p>
                      </div>
                      <div data-id="element-2445">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2446">Top Agent</p>
                        <p className="text-sm font-semibold text-[#1388ad]" data-id="element-2447">
                          {property.topAgent}
                        </p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Top Performers */}
            <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-2448">
              <div className="flex items-start gap-3 mb-6" data-id="element-2449">
                <div className="p-2 bg-[#1388ad]/10 rounded-lg" data-id="element-2450">
                  <Users className="w-5 h-5 text-[#1388ad]" data-id="element-2451" />
                </div>
                <div data-id="element-2452">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-2453">
                    Team Members - Trattative Simili
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-2454">
                    Agenti con maggior esperienza su immobili comparabili
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4" data-id="element-2455">
                {mockHistoricalData.topPerformers.map((agent, idx) => <div key={agent.name} className="p-5 border-2 border-gray-200 rounded-lg hover:border-[#1388ad] transition-all" data-id="element-2456">
                    <div className="flex items-center gap-3 mb-4" data-id="element-2457">
                      <div className="relative" data-id="element-2458">
                        <div className="w-12 h-12 bg-[#1388ad] rounded-full flex items-center justify-center text-white text-sm font-semibold" data-id="element-2459">
                          {agent.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        {idx === 0 && <div className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-400 rounded-full flex items-center justify-center" data-id="element-2460">
                            <span className="text-xs" data-id="element-2461">🏆</span>
                          </div>}
                      </div>
                      <div data-id="element-2462">
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2463">
                          {agent.name}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2464">{agent.role}</p>
                      </div>
                    </div>

                    <div className="space-y-3" data-id="element-2465">
                      <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2466">
                        <p className="text-xs text-gray-600 mb-1" data-id="element-2467">
                          Specializzazione
                        </p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2468">
                          {agent.specialization}
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-2" data-id="element-2469">
                        <div data-id="element-2470">
                          <p className="text-xs text-gray-500 mb-1" data-id="element-2471">
                            Trattative
                          </p>
                          <p className="text-lg font-bold text-gray-900" data-id="element-2472">
                            {agent.dealsInCategory}
                          </p>
                        </div>
                        <div data-id="element-2473">
                          <p className="text-xs text-gray-500 mb-1" data-id="element-2474">Successo</p>
                          <p className="text-lg font-bold text-[#1388ad]" data-id="element-2475">
                            {agent.successRate}%
                          </p>
                        </div>
                      </div>

                      <div className="pt-3 border-t border-gray-200" data-id="element-2476">
                        <div className="flex items-center justify-between text-xs" data-id="element-2477">
                          <span className="text-gray-600" data-id="element-2478">Valore Totale</span>
                          <span className="font-semibold text-gray-900" data-id="element-2479">
                            {agent.totalValue}
                          </span>
                        </div>
                        <div className="flex items-center justify-between text-xs mt-1" data-id="element-2480">
                          <span className="text-gray-600" data-id="element-2481">Giorni Medi</span>
                          <span className="font-semibold text-gray-900" data-id="element-2482">
                            {agent.avgDaysToClose}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Brand Categories Performance */}
            

            {/* Info Footer */}
            <div className="bg-white border border-gray-200 rounded-lg p-6" data-id="element-2483">
              <div className="grid grid-cols-2 gap-6" data-id="element-2484">
                <div className="flex items-start gap-3" data-id="element-2485">
                  <div className="p-2 bg-[#1388ad]/10 rounded-lg flex-shrink-0" data-id="element-2486">
                    <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2487" />
                  </div>
                  <div data-id="element-2488">
                    <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2489">
                      Analisi Basata su Storico Reale
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-2490">
                      I dati sono estratti da{' '}
                      {mockHistoricalData.performanceMetrics.totalDealsInZone}{' '}
                      trattative reali chiuse da Edares in zone e tipologie
                      comparabili.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2491">
                  <div className="p-2 bg-gray-100 rounded-lg flex-shrink-0" data-id="element-2492">
                    <Users className="w-5 h-5 text-gray-700" data-id="element-2493" />
                  </div>
                  <div data-id="element-2494">
                    <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2495">
                      Team Expertise
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-2496">
                      Gli agenti suggeriti hanno track record comprovato su
                      immobili simili con tassi di successo superiori all'80%.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> : viewMode === 'scheda' ? <div className="bg-white border border-gray-200 rounded-lg overflow-hidden p-6" data-id="element-2497">
          <div className="space-y-6" data-id="element-2498">
            <div className="flex items-center justify-between" data-id="element-2499">
              <div data-id="element-2500">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-2501">
                  Genera Scheda Immobile
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-2502">
                  Personalizza ogni slide e scarica la scheda in PDF
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-2503">
                <button onClick={() => setShowZoomModal(true)} className="p-2 border-2 border-gray-300 text-gray-700 rounded-full hover:bg-gray-50 transition-colors" title="Visualizza in Zoom" data-id="element-2504">
                  <Eye className="w-5 h-5" data-id="element-2505" />
                </button>
                <button className="flex items-center gap-2 px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-normal rounded-full hover:bg-gray-50 transition-colors" data-id="element-2506">
                  <Download className="w-4 h-4" data-id="element-2507" />
                  Scarica PDF
                </button>
                <button onClick={handleOpenCampaignModal} className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-2508">
                  <Mail className="w-4 h-4" data-id="element-2509" />
                  Invia Campagna
                </button>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2510">
              <div className="lg:col-span-2 space-y-4" data-id="element-2511">
                <div className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden aspect-[16/10]" data-id="element-2512">
                  {schedaPages[currentPage]?.content}
                </div>
                <div className="flex items-center justify-between" data-id="element-2513">
                  <button onClick={() => setCurrentPage(Math.max(0, currentPage - 1))} disabled={currentPage === 0} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2514">
                    <ChevronLeft className="w-4 h-4" data-id="element-2515" />
                    Precedente
                  </button>
                  <div className="flex items-center gap-2" data-id="element-2516">
                    {schedaPages.map((_, idx) => <button key={idx} onClick={() => setCurrentPage(idx)} className={`w-2 h-2 rounded-full transition-colors ${currentPage === idx ? 'bg-[#1388ad] w-6' : 'bg-gray-300'}`} data-id="element-2517" />)}
                  </div>
                  <button onClick={() => setCurrentPage(Math.min(schedaPages.length - 1, currentPage + 1))} disabled={currentPage === schedaPages.length - 1} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2518">
                    Successiva
                    <ChevronRight className="w-4 h-4" data-id="element-2519" />
                  </button>
                </div>
                <div className="text-center text-sm text-gray-500" data-id="element-2520">
                  Pagina {currentPage + 1} di {schedaPages.length} -{' '}
                  {schedaPages[currentPage]?.title}
                </div>
              </div>
              <div className="space-y-6" data-id="element-2521">
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-2522">
                  <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2" data-id="element-2523">
                    <Layout className="w-4 h-4" data-id="element-2524" />
                    Personalizza Slide: {schedaPages[currentPage]?.title}
                  </h3>
                  {/* Copertina Settings */}
                  {currentPage === 0 && <div className="space-y-3" data-id="element-2525">
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2526">
                        <input type="checkbox" checked={slideSettings[0].showPrice} onChange={e => updateSlideSettings(0, {
                    showPrice: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2527" />
                        <span className="text-sm text-gray-700" data-id="element-2528">
                          Mostra prezzo
                        </span>
                      </label>
                      <div data-id="element-2529">
                        <label className="block text-xs text-gray-600 mb-2" data-id="element-2530">
                          Layout
                        </label>
                        <select value={slideSettings[0].layout} onChange={e => updateSlideSettings(0, {
                    layout: e.target.value
                  })} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2531">
                          <option value="overlay" data-id="element-2532">Overlay centrale</option>
                          <option value="bottom" data-id="element-2533">Testo in basso</option>
                          <option value="side" data-id="element-2534">Testo laterale</option>
                        </select>
                      </div>
                    </div>}
                  {/* Specifiche Settings */}
                  {currentPage === 1 && <div className="space-y-3" data-id="element-2535">
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2536">
                        <input type="checkbox" checked={slideSettings[1].showImages} onChange={e => updateSlideSettings(1, {
                    showImages: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2537" />
                        <span className="text-sm text-gray-700" data-id="element-2538">
                          Mostra immagini
                        </span>
                      </label>
                      <div data-id="element-2539">
                        <label className="block text-xs text-gray-600 mb-2" data-id="element-2540">
                          Colonne layout
                        </label>
                        <select value={slideSettings[1].columns} onChange={e => updateSlideSettings(1, {
                    columns: parseInt(e.target.value)
                  })} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2541">
                          <option value="1" data-id="element-2542">1 colonna</option>
                          <option value="2" data-id="element-2543">2 colonne</option>
                        </select>
                      </div>
                    </div>}
                  {/* Planimetria Settings */}
                  {currentPage === 2 && <div className="space-y-3" data-id="element-2544">
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2545">
                        <input type="checkbox" checked={slideSettings[2].showMeasurements} onChange={e => updateSlideSettings(2, {
                    showMeasurements: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2546" />
                        <span className="text-sm text-gray-700" data-id="element-2547">
                          Mostra misure
                        </span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2548">
                        <input type="checkbox" checked={slideSettings[2].showLegend} onChange={e => updateSlideSettings(2, {
                    showLegend: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2549" />
                        <span className="text-sm text-gray-700" data-id="element-2550">
                          Mostra legenda
                        </span>
                      </label>
                    </div>}
                  {/* Galleria Settings */}
                  {currentPage === 3 && <div className="space-y-3" data-id="element-2551">
                      <div data-id="element-2552">
                        <label className="block text-xs text-gray-600 mb-2" data-id="element-2553">
                          Griglia immagini
                        </label>
                        <select value={slideSettings[3].gridCols} onChange={e => updateSlideSettings(3, {
                    gridCols: parseInt(e.target.value)
                  })} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2554">
                          <option value="2" data-id="element-2555">2 colonne</option>
                          <option value="3" data-id="element-2556">3 colonne</option>
                          <option value="4" data-id="element-2557">4 colonne</option>
                        </select>
                      </div>
                    </div>}
                  {/* Street Map Settings */}
                  {currentPage === 4 && <div className="space-y-3" data-id="element-2558">
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2559">
                        <input type="checkbox" checked={slideSettings[4].showStats} onChange={e => updateSlideSettings(4, {
                    showStats: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2560" />
                        <span className="text-sm text-gray-700" data-id="element-2561">
                          Mostra statistiche
                        </span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer" data-id="element-2562">
                        <input type="checkbox" checked={slideSettings[4].showLegend} onChange={e => updateSlideSettings(4, {
                    showLegend: e.target.checked
                  })} className="text-[#1388ad] focus:ring-[#1388ad]" data-id="element-2563" />
                        <span className="text-sm text-gray-700" data-id="element-2564">
                          Mostra legenda
                        </span>
                      </label>
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div> : <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2565">
          <div className="border-b border-gray-200" data-id="element-2566">
            <div className="flex overflow-x-auto" data-id="element-2567">
              {tabs.map(tab => {
            const Icon = tab.icon;
            return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-4 text-sm font-normal whitespace-nowrap transition-colors border-b-2 ${activeTab === tab.id ? 'border-[#1388ad] text-[#1388ad] bg-[#1388ad]/5' : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-2568">
                    <Icon className="w-4 h-4" data-id="element-2569" />
                    {tab.label}
                  </button>;
          })}
            </div>
          </div>
          <div className="p-6" data-id="element-2570">
            {activeTab === 'info' && <div className="space-y-6" data-id="element-2571">
                <div className="flex items-center justify-between mb-4" data-id="element-2572">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2573">
                    Dettagli Immobile
                  </h2>
                  <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-2574">
                    <Edit className="w-4 h-4" data-id="element-2575" />
                    Modifica
                  </button>
                </div>
                <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2576">
                  <div className="grid grid-cols-4 divide-x divide-gray-200" data-id="element-2577">
                    <div className="p-6" data-id="element-2578">
                      <div className="flex items-center gap-2 text-gray-500 mb-3" data-id="element-2579">
                        <Ruler className="w-5 h-5" data-id="element-2580" />
                        <span className="text-sm font-medium" data-id="element-2581">Superficie</span>
                      </div>
                      <p className="text-xl font-semibold text-gray-900" data-id="element-2582">
                        {mockPropertyData.size}
                      </p>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2583">
                        metri quadrati
                      </p>
                    </div>
                    <div className="p-6" data-id="element-2584">
                      <div className="flex items-center gap-2 text-gray-500 mb-3" data-id="element-2585">
                        <Building className="w-5 h-5" data-id="element-2586" />
                        <span className="text-sm font-medium" data-id="element-2587">Piano</span>
                      </div>
                      <p className="text-xl font-semibold text-gray-900" data-id="element-2588">
                        {mockPropertyData.floor}
                      </p>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2589">posizione</p>
                    </div>
                    <div className="p-6" data-id="element-2590">
                      <div className="flex items-center gap-2 text-gray-500 mb-3" data-id="element-2591">
                        <Calendar className="w-5 h-5" data-id="element-2592" />
                        <span className="text-sm font-medium" data-id="element-2593">
                          Disponibilità
                        </span>
                      </div>
                      <p className="text-xl font-semibold text-gray-900" data-id="element-2594">
                        {mockPropertyData.availability}
                      </p>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2595">
                        per l'occupazione
                      </p>
                    </div>
                    <div className="p-6" data-id="element-2596">
                      <div className="flex items-center gap-2 text-gray-500 mb-3" data-id="element-2597">
                        <Users className="w-5 h-5" data-id="element-2598" />
                        <span className="text-sm font-medium" data-id="element-2599">
                          Brand Interessati
                        </span>
                      </div>
                      <p className="text-xl font-semibold text-gray-900" data-id="element-2600">
                        {mockPropertyData.interested}
                      </p>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2601">
                        contatti attivi
                      </p>
                    </div>
                  </div>
                </div>
                <div data-id="element-2602">
                  <h2 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-2603">
                    Descrizione
                  </h2>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2604">
                    {mockPropertyData.description}
                  </p>
                </div>
                <div data-id="element-2605">
                  <h2 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-2606">
                    Caratteristiche
                  </h2>
                  <div className="grid grid-cols-2 gap-3" data-id="element-2607">
                    {mockPropertyData.features.map((feature, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2608">
                        <span className="w-2 h-2 bg-[#1388ad]" data-id="element-2609"></span>
                        <span data-id="element-2610">{feature}</span>
                      </div>)}
                  </div>
                </div>
              </div>}
            {activeTab === 'gallery' && <div className="space-y-4" data-id="element-2611">
                <div className="flex items-center justify-between" data-id="element-2612">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2613">
                    Galleria Immagini
                  </h2>
                  <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-2614">
                    <Edit className="w-4 h-4" data-id="element-2615" />
                    Gestisci Galleria
                  </button>
                </div>
                <div className="grid grid-cols-4 gap-4" data-id="element-2616">
                  {mockPropertyData.gallery.map((img, idx) => <div key={idx} className="aspect-square" data-id="element-2617">
                      <img src={img} alt={`Gallery ${idx + 1}`} className="w-full h-full object-cover rounded-lg hover:scale-105 transition-transform cursor-pointer" data-id="element-2618" />
                    </div>)}
                </div>
              </div>}
            {activeTab === 'planimetria' && <div className="space-y-4" data-id="element-2619">
                <div className="flex items-center justify-between px-6" data-id="element-2620">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2621">
                    Planimetria
                  </h2>
                  <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-2622">
                    <Edit className="w-4 h-4" data-id="element-2623" />
                    Modifica Planimetria
                  </button>
                </div>
                <FloorPlanVisualization data-id="element-2624" />
              </div>}
            {activeTab === 'streetmap' && <div className="space-y-6" data-id="element-2625">
                <div className="flex items-center justify-between mb-4" data-id="element-2626">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2627">
                    Analisi Zona e Traffico
                  </h2>
                  <button onClick={() => setShowStreetMapModal(true)} className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-2628">
                    <MapPin className="w-4 h-4" data-id="element-2629" />
                    Visualizza Mappa Strada
                  </button>
                </div>
                <div className="grid grid-cols-3 gap-4" data-id="element-2630">
                  <div className="p-4 bg-[#1388ad]/10 border border-[#1388ad]/20 rounded-lg" data-id="element-2631">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2632">
                      <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2633" />
                      <span className="text-sm font-semibold text-gray-900" data-id="element-2634">
                        Traffico
                      </span>
                    </div>
                    <p className="text-2xl font-bold text-[#1388ad] mb-1" data-id="element-2635">
                      {mockStreetData.trafficScore}/100
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-2636">
                      {mockStreetData.trafficLevel}
                    </p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg" data-id="element-2637">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2638">
                      <Users className="w-5 h-5 text-gray-600" data-id="element-2639" />
                      <span className="text-sm font-semibold text-gray-900" data-id="element-2640">
                        Flusso Pedonale
                      </span>
                    </div>
                    <p className="text-lg font-bold text-gray-900" data-id="element-2641">
                      {mockStreetData.pedestrianFlow}
                    </p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg" data-id="element-2642">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2643">
                      <Store className="w-5 h-5 text-gray-600" data-id="element-2644" />
                      <span className="text-sm font-semibold text-gray-900" data-id="element-2645">
                        Brand Vicini
                      </span>
                    </div>
                    <p className="text-lg font-bold text-gray-900" data-id="element-2646">
                      {mockStreetData.brandPresence.length}
                    </p>
                  </div>
                </div>
                <div data-id="element-2647">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2648">
                    Brand Presenti nella Via
                  </h3>
                  <div className="space-y-3" data-id="element-2649">
                    {mockStreetData.brandPresence.map((brand, idx) => <div key={idx} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2650">
                        <div className="flex items-center gap-3" data-id="element-2651">
                          <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center" data-id="element-2652">
                            <Store className="w-5 h-5 text-[#1388ad]" data-id="element-2653" />
                          </div>
                          <div data-id="element-2654">
                            <p className="text-sm font-semibold text-gray-900" data-id="element-2655">
                              {brand.name}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-2656">
                              {brand.category}
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-gray-600" data-id="element-2657">
                          {brand.distance}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>}
            {activeTab === 'ecoscore' && <div className="space-y-6" data-id="element-2658">
                <div className="flex items-center justify-between mb-4" data-id="element-2659">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2660">
                    Analisi Sostenibilità
                  </h2>
                  <div className="flex items-center gap-2" data-id="element-2661">
                    <span className="px-3 py-1 bg-[#1388ad]/10 text-[#1388ad] text-sm font-semibold rounded-full" data-id="element-2662">
                      {mockEcoScoreData.scoreLevel}
                    </span>
                  </div>
                </div>
                {/* Overall Score */}
                <div className="bg-gradient-to-br from-[#1388ad]/5 to-[#1388ad]/10 border border-gray-200 rounded-lg p-6" data-id="element-2663">
                  <div className="flex items-center justify-between" data-id="element-2664">
                    <div data-id="element-2665">
                      <div className="flex items-center gap-3 mb-2" data-id="element-2666">
                        <Leaf className="w-8 h-8 text-[#1388ad]" data-id="element-2667" />
                        <h3 className="text-2xl font-bold text-gray-900" data-id="element-2668">
                          Eco Score
                        </h3>
                      </div>
                      <p className="text-sm text-gray-600" data-id="element-2669">
                        Valutazione complessiva di sostenibilità
                      </p>
                    </div>
                    <div className="text-center" data-id="element-2670">
                      <div className="text-5xl font-bold text-[#1388ad] mb-1" data-id="element-2671">
                        {mockEcoScoreData.overallScore}
                      </div>
                      <div className="text-sm text-gray-600" data-id="element-2672">su 100</div>
                    </div>
                  </div>
                </div>
                {/* Categories */}
                <div data-id="element-2673">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2674">
                    Categorie di Sostenibilità
                  </h3>
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2675">
                    {mockEcoScoreData.categories.map((category, idx) => <div key={idx} className="p-4 bg-white border border-gray-200 rounded-lg hover:border-[#1388ad]/50 transition-colors" data-id="element-2676">
                        <div className="text-3xl mb-2" data-id="element-2677">{category.icon}</div>
                        <p className="text-sm font-semibold text-gray-900 mb-2" data-id="element-2678">
                          {category.name}
                        </p>
                        <div className="flex items-center gap-2" data-id="element-2679">
                          <div className="flex-1 bg-gray-200 rounded-full h-2" data-id="element-2680">
                            <div className="bg-[#1388ad] h-2 rounded-full transition-all" style={{
                      width: `${category.score}%`
                    }} data-id="element-2681" />
                          </div>
                          <span className="text-sm font-bold text-[#1388ad]" data-id="element-2682">
                            {category.score}
                          </span>
                        </div>
                      </div>)}
                  </div>
                </div>
                {/* Parameters */}
                <div data-id="element-2683">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2684">
                    Parametri di Sostenibilità
                  </h3>
                  <div className="space-y-4" data-id="element-2685">
                    {mockEcoScoreData.parameters.map((param, idx) => <div key={idx} className="p-5 bg-white border border-gray-200 rounded-lg" data-id="element-2686">
                        <h4 className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2" data-id="element-2687">
                          <CheckCircle className="w-4 h-4 text-[#1388ad]" data-id="element-2688" />
                          {param.category}
                        </h4>
                        <div className="grid grid-cols-1 gap-1" data-id="element-2689">
                          {param.items.map((item, itemIdx) => <div key={itemIdx} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-2690">
                              <span className="w-1.5 h-1.5 bg-[#1388ad] rounded-full mt-1.5 flex-shrink-0" data-id="element-2691" />
                              <span data-id="element-2692">{item}</span>
                            </div>)}
                        </div>
                      </div>)}
                  </div>
                </div>
                {/* Economic Impact */}
                <div data-id="element-2693">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2694">
                    Impatto Economico e Valore
                  </h3>
                  <div className="grid grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-2695">
                    <div className="p-4 bg-white border border-gray-200 rounded-lg" data-id="element-2696">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-2697">
                        Risparmio Energetico
                      </p>
                      <p className="text-2xl font-bold text-[#1388ad]" data-id="element-2698">
                        {mockEcoScoreData.economicImpact.energySavings}
                      </p>
                    </div>
                    <div className="p-4 bg-white border border-gray-200 rounded-lg" data-id="element-2699">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-2700">
                        Risparmio Idrico
                      </p>
                      <p className="text-2xl font-bold text-[#1388ad]" data-id="element-2701">
                        {mockEcoScoreData.economicImpact.waterSavings}
                      </p>
                    </div>
                    <div className="p-4 bg-white border border-gray-200 rounded-lg" data-id="element-2702">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-2703">
                        Riduzione Manutenzione
                      </p>
                      <p className="text-2xl font-bold text-[#1388ad]" data-id="element-2704">
                        {mockEcoScoreData.economicImpact.maintenanceReduction}
                      </p>
                    </div>
                    <div className="p-4 bg-white border border-gray-200 rounded-lg" data-id="element-2705">
                      <p className="text-xs text-gray-600 mb-1" data-id="element-2706">
                        Aumento Valore
                      </p>
                      <p className="text-2xl font-bold text-[#1388ad]" data-id="element-2707">
                        {mockEcoScoreData.economicImpact.valueIncrease}
                      </p>
                    </div>
                    <div className="p-4 bg-[#1388ad]/10 border border-[#1388ad]/20 rounded-lg" data-id="element-2708">
                      <p className="text-xs text-[#1388ad] mb-1" data-id="element-2709">
                        Risparmio Annuale
                      </p>
                      <p className="text-xl font-bold text-[#1388ad]" data-id="element-2710">
                        €{' '}
                        {mockEcoScoreData.economicImpact.annualSavings.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Certifications */}
                <div data-id="element-2711">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2712">
                    Certificazioni
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2713">
                    {mockEcoScoreData.certifications.map((cert, idx) => <div key={idx} className="p-5 bg-white border border-gray-200 rounded-lg" data-id="element-2714">
                        <div className="flex items-start gap-4" data-id="element-2715">
                          <div className="w-16 h-16 bg-[#1388ad] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-2716">
                            <CheckCircle className="w-8 h-8 text-white" data-id="element-2717" />
                          </div>
                          <div className="flex-1" data-id="element-2718">
                            <div className="flex items-center gap-2 mb-1" data-id="element-2719">
                              <h4 className="text-base font-semibold text-gray-900" data-id="element-2720">
                                {cert.name}
                              </h4>
                              <span className="px-2 py-0.5 bg-[#1388ad]/10 text-[#1388ad] text-xs rounded-full" data-id="element-2721">
                                {cert.year}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600" data-id="element-2722">
                              {cert.description}
                            </p>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </div>
                {/* Info Box */}
                <div className="bg-[#1388ad]/5 border border-[#1388ad]/20 rounded-lg p-4" data-id="element-2723">
                  <div className="flex gap-3" data-id="element-2724">
                    <Info className="w-5 h-5 text-[#1388ad] flex-shrink-0 mt-0.5" data-id="element-2725" />
                    <div data-id="element-2726">
                      <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2727">
                        Valore Aggiunto dalla Sostenibilità
                      </p>
                      <p className="text-xs text-gray-600 leading-relaxed" data-id="element-2728">
                        Gli immobili con elevati standard di sostenibilità
                        registrano un aumento medio del valore di mercato del
                        15-20% e attraggono inquilini di qualità superiore
                        disposti a pagare canoni premium. Il risparmio sui costi
                        operativi e la ridotta manutenzione garantiscono un ROI
                        superiore nel lungo periodo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>}
            {activeTab === 'trattative' && <div className="space-y-4" data-id="element-2729">
                {mockTrattative.map(trattativa => <div key={trattativa.id} className="p-6 border border-gray-200 rounded-lg hover:border-[#1388ad] transition-colors" data-id="element-2730">
                    <div className="flex items-start justify-between mb-4" data-id="element-2731">
                      <div data-id="element-2732">
                        <div className="flex items-center gap-3 mb-2" data-id="element-2733">
                          <h3 className="text-lg font-semibold text-gray-900" data-id="element-2734">
                            {trattativa.brand}
                          </h3>
                          <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full" data-id="element-2735">
                            {trattativa.category}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600" data-id="element-2736">
                          Referente: {trattativa.contact}
                        </p>
                      </div>
                      <span className={`px-3 py-1 text-xs font-normal rounded-full ${stageColors[trattativa.stage]}`} data-id="element-2737">
                        {trattativa.stage}
                      </span>
                    </div>
                    <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-2738">
                      <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2739">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2740">Budget</p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2741">
                          {trattativa.budget}
                        </p>
                      </div>
                      <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2742">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2743">
                          Data Inizio
                        </p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2744">
                          {trattativa.startDate}
                        </p>
                      </div>
                      <div className="p-3 bg-gray-50 rounded-lg" data-id="element-2745">
                        <p className="text-xs text-gray-500 mb-1" data-id="element-2746">
                          Ultimo Aggiornamento
                        </p>
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2747">
                          {trattativa.lastUpdate}
                        </p>
                      </div>
                    </div>
                    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-2748">
                      <p className="text-xs text-blue-700 mb-1" data-id="element-2749">Note</p>
                      <p className="text-sm text-blue-900" data-id="element-2750">
                        {trattativa.notes}
                      </p>
                    </div>
                  </div>)}
              </div>}
          </div>
        </div>}
      {/* Zoom Modal */}
      {showZoomModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50 p-8" data-id="element-2751">
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="relative w-full h-full max-w-7xl max-h-full" data-id="element-2752">
            <button onClick={() => setShowZoomModal(false)} className="absolute -top-12 right-0 p-2 bg-white hover:bg-gray-100 transition-colors rounded-full z-10" data-id="element-2753">
              <X className="w-6 h-6 text-gray-900" data-id="element-2754" />
            </button>
            <div className="bg-white rounded-lg overflow-hidden w-full h-full flex flex-col" data-id="element-2755">
              <div className="flex-1 overflow-auto" data-id="element-2756">
                <div className="w-full h-full p-4" data-id="element-2757">
                  {schedaPages[currentPage]?.content}
                </div>
              </div>
              <div className="border-t border-gray-200 p-4 bg-white" data-id="element-2758">
                <div className="flex items-center justify-between" data-id="element-2759">
                  <button onClick={() => setCurrentPage(Math.max(0, currentPage - 1))} disabled={currentPage === 0} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2760">
                    <ChevronLeft className="w-4 h-4" data-id="element-2761" />
                    Precedente
                  </button>
                  <div className="flex items-center gap-3" data-id="element-2762">
                    <span className="text-sm text-gray-600" data-id="element-2763">
                      Pagina {currentPage + 1} di {schedaPages.length}
                    </span>
                    <div className="flex items-center gap-2" data-id="element-2764">
                      {schedaPages.map((_, idx) => <button key={idx} onClick={() => setCurrentPage(idx)} className={`w-2 h-2 rounded-full transition-colors ${currentPage === idx ? 'bg-[#1388ad] w-6' : 'bg-gray-300'}`} data-id="element-2765" />)}
                    </div>
                  </div>
                  <button onClick={() => setCurrentPage(Math.min(schedaPages.length - 1, currentPage + 1))} disabled={currentPage === schedaPages.length - 1} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-2766">
                    Successiva
                    <ChevronRight className="w-4 h-4" data-id="element-2767" />
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>}
      {/* Campaign Modal */}
      {showCampaignModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-2768">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-lg" data-id="element-2769">
            {campaignStep === 'loading' && <div className="p-12" data-id="element-2770">
                <div className="text-center space-y-6" data-id="element-2771">
                  <div className="flex justify-center" data-id="element-2772">
                    <div className="relative" data-id="element-2773">
                      <Loader2 className="w-16 h-16 text-[#1388ad] animate-spin" data-id="element-2774" />
                      <div className="absolute inset-0 flex items-center justify-center" data-id="element-2775">
                        <TrendingUp className="w-8 h-8 text-[#1388ad]" data-id="element-2776" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-2777">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-2778">
                      Analisi AI in corso...
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-2779">
                      Sto analizzando l'immobile e identificando i brand più
                      adatti per questa campagna
                    </p>
                  </div>
                  <div className="space-y-2 text-left max-w-md mx-auto" data-id="element-2780">
                    <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 0.5
              }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2781">
                      <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2782" />
                      Analisi caratteristiche immobile
                    </motion.div>
                    <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 1
              }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2783">
                      <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2784" />
                      Valutazione zona e traffico
                    </motion.div>
                    <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 1.5
              }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2785">
                      <CheckCircle className="w-4 h-4 text-green-600" data-id="element-2786" />
                      Matching con database brand
                    </motion.div>
                    <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 2
              }} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2787">
                      <Loader2 className="w-4 h-4 text-[#1388ad] animate-spin" data-id="element-2788" />
                      Generazione raccomandazioni...
                    </motion.div>
                  </div>
                </div>
              </div>}
            {campaignStep === 'brands' && <div data-id="element-2789">
                <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-lg" data-id="element-2790">
                  <div className="flex items-center justify-between" data-id="element-2791">
                    <div data-id="element-2792">
                      <h2 className="text-xl font-semibold text-gray-900" data-id="element-2793">
                        Brand Suggeriti dall'AI
                      </h2>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2794">
                        Seleziona i brand a cui inviare la campagna
                      </p>
                    </div>
                    <button onClick={() => setShowCampaignModal(false)} className="p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-2795">
                      <X className="w-5 h-5 text-gray-500" data-id="element-2796" />
                    </button>
                  </div>
                </div>
                <div className="p-6 space-y-4" data-id="element-2797">
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-2798">
                    <div className="flex gap-3" data-id="element-2799">
                      <Lightbulb className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-2800" />
                      <div data-id="element-2801">
                        <p className="text-sm font-semibold text-blue-900" data-id="element-2802">
                          {suggestedBrands.length} brand identificati
                        </p>
                        <p className="text-xs text-blue-800 mt-1" data-id="element-2803">
                          L'AI ha analizzato l'immobile e suggerisce questi
                          brand in base a location, caratteristiche e budget
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-2804">
                    {suggestedBrands.map((brand, idx) => <motion.div key={brand.name} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: idx * 0.1
              }} className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${selectedBrands.includes(brand.name) ? 'border-[#1388ad] bg-[#1388ad]/5' : 'border-gray-200 hover:border-gray-300'}`} onClick={() => handleToggleBrand(brand.name)} data-id="element-2805">
                        <div className="flex items-center justify-between" data-id="element-2806">
                          <div className="flex items-center gap-3" data-id="element-2807">
                            <input type="checkbox" checked={selectedBrands.includes(brand.name)} onChange={() => handleToggleBrand(brand.name)} className="w-5 h-5 text-[#1388ad] rounded focus:ring-[#1388ad]" data-id="element-2808" />
                            <div data-id="element-2809">
                              <p className="text-sm font-semibold text-gray-900" data-id="element-2810">
                                {brand.name}
                              </p>
                              <p className="text-xs text-gray-500" data-id="element-2811">
                                {brand.category}
                              </p>
                            </div>
                          </div>
                          <div className="flex items-center gap-2" data-id="element-2812">
                            <div className="text-right" data-id="element-2813">
                              <p className="text-xs text-gray-500" data-id="element-2814">Match AI</p>
                              <p className="text-sm font-semibold text-[#1388ad]" data-id="element-2815">
                                {brand.match}%
                              </p>
                            </div>
                            <div className="w-12 h-12 bg-[#1388ad]/10 rounded-full flex items-center justify-center" data-id="element-2816">
                              <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2817" />
                            </div>
                          </div>
                        </div>
                      </motion.div>)}
                  </div>
                </div>
                <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6 rounded-b-lg" data-id="element-2818">
                  <div className="flex items-center justify-between" data-id="element-2819">
                    <p className="text-sm text-gray-600" data-id="element-2820">
                      {selectedBrands.length} brand selezionati
                    </p>
                    <div className="flex items-center gap-3" data-id="element-2821">
                      <button onClick={() => setShowCampaignModal(false)} className="px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-normal rounded-full hover:bg-gray-50 transition-colors" data-id="element-2822">
                        Annulla
                      </button>
                      <button onClick={handleContinueToSchedule} disabled={selectedBrands.length === 0} className="px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2823">
                        Continua
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            {campaignStep === 'schedule' && <div data-id="element-2824">
                <div className="sticky top-0 bg-white border-b border-gray-200 p-6 rounded-t-lg" data-id="element-2825">
                  <div className="flex items-center justify-between" data-id="element-2826">
                    <div data-id="element-2827">
                      <h2 className="text-xl font-semibold text-gray-900" data-id="element-2828">
                        Programma Invio
                      </h2>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-2829">
                        Scegli quando inviare la campagna ai{' '}
                        {selectedBrands.length} brand selezionati
                      </p>
                    </div>
                    <button onClick={() => setShowCampaignModal(false)} className="p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-2830">
                      <X className="w-5 h-5 text-gray-500" data-id="element-2831" />
                    </button>
                  </div>
                </div>
                <div className="p-6 space-y-6" data-id="element-2832">
                  <div className="bg-[#1388ad]/5 border border-[#1388ad]/20 rounded-lg p-4" data-id="element-2833">
                    <div className="flex gap-3" data-id="element-2834">
                      <Users className="w-5 h-5 text-[#1388ad] flex-shrink-0 mt-0.5" data-id="element-2835" />
                      <div data-id="element-2836">
                        <p className="text-sm font-semibold text-gray-900 mb-2" data-id="element-2837">
                          Brand Selezionati
                        </p>
                        <div className="flex flex-wrap gap-2" data-id="element-2838">
                          {selectedBrands.map(brand => <span key={brand} className="px-3 py-1 bg-white border border-[#1388ad]/30 text-[#1388ad] text-xs rounded-full" data-id="element-2839">
                              {brand}
                            </span>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-2840">
                    <div data-id="element-2841">
                      <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-2842">
                        Data Invio
                      </label>
                      <input type="date" value={campaignDate} onChange={e => setCampaignDate(e.target.value)} min={new Date().toISOString().split('T')[0]} className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2843" />
                    </div>
                    <div data-id="element-2844">
                      <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-2845">
                        Orario Invio
                      </label>
                      <input type="time" value={campaignTime} onChange={e => setCampaignTime(e.target.value)} className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-2846" />
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-2847">
                    <p className="text-sm font-semibold text-gray-900" data-id="element-2848">
                      Orari Consigliati
                    </p>
                    <div className="grid grid-cols-3 gap-3" data-id="element-2849">
                      {['09:00', '14:00', '17:00'].map(time => <button key={time} onClick={() => setCampaignTime(time)} className={`p-3 text-sm rounded-lg transition-colors ${campaignTime === time ? 'bg-[#1388ad] text-white' : 'bg-gray-50 text-gray-700 hover:bg-gray-100'}`} data-id="element-2850">
                          {time}
                        </button>)}
                    </div>
                  </div>
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-2851">
                    <div className="flex gap-3" data-id="element-2852">
                      <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-2853" />
                      <div data-id="element-2854">
                        <p className="text-sm font-semibold text-blue-900" data-id="element-2855">
                          Suggerimento AI
                        </p>
                        <p className="text-xs text-blue-800 mt-1" data-id="element-2856">
                          Gli orari migliori per l'invio sono tra le 9:00-11:00
                          o 14:00-16:00 per massimizzare il tasso di apertura
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6 rounded-b-lg" data-id="element-2857">
                  <div className="flex items-center justify-between" data-id="element-2858">
                    <button onClick={() => setCampaignStep('brands')} className="flex items-center gap-2 px-4 py-2 text-gray-700 text-sm font-normal hover:bg-gray-50 rounded-full transition-colors" data-id="element-2859">
                      <ChevronLeft className="w-4 h-4" data-id="element-2860" />
                      Indietro
                    </button>
                    <div className="flex items-center gap-3" data-id="element-2861">
                      <button onClick={() => setShowCampaignModal(false)} className="px-4 py-2 border-2 border-gray-300 text-gray-700 text-sm font-normal rounded-full hover:bg-gray-50 transition-colors" data-id="element-2862">
                        Annulla
                      </button>
                      <button onClick={handleSendCampaign} disabled={!campaignDate || !campaignTime} className="flex items-center gap-2 px-6 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-2863">
                        <Mail className="w-4 h-4" data-id="element-2864" />
                        Invia Campagna
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
          </motion.div>
        </div>}
      {/* Street Map Modal */}
      {showStreetMapModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-2865">
          <div className="bg-white w-full max-w-6xl max-h-[90vh] overflow-y-auto rounded-lg" data-id="element-2866">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between rounded-t-lg" data-id="element-2867">
              <div data-id="element-2868">
                <h2 className="text-xl font-semibold text-gray-900" data-id="element-2869">
                  Mappa Via Montenapoleone
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-2870">
                  Vista della strada con negozi su entrambi i lati
                </p>
              </div>
              <button onClick={() => setShowStreetMapModal(false)} className="p-2 hover:bg-gray-100 transition-colors rounded-full" data-id="element-2871">
                <X className="w-5 h-5 text-gray-500" data-id="element-2872" />
              </button>
            </div>
            <div className="p-6" data-id="element-2873">
              <div className="overflow-x-auto" data-id="element-2874">
                <svg width="1200" height="450" viewBox="0 0 1200 450" style={{
              maxWidth: '100%'
            }} className="border border-gray-200 rounded-lg" data-id="element-2875">
                  {/* Background */}
                  <rect x="0" y="0" width="1200" height="450" fill="white" data-id="element-2876" />
                  {/* Sidewalk - top */}
                  <rect x="30" y="60" width="940" height="110" fill="transparent" rx="4" data-id="element-2877" />
                  {/* Street/Road */}
                  <rect x="30" y="180" width="940" height="90" fill="white" stroke="#dee2e6" strokeWidth="2" rx="4" data-id="element-2878" />
                  {/* Road markings */}
                  <line x1="30" y1="225" x2="970" y2="225" stroke="#fff" strokeWidth="2" strokeDasharray="20,15" opacity="0.5" data-id="element-2879" />
                  {/* Sidewalk - bottom */}
                  <rect x="30" y="280" width="940" height="110" fill="transparent" rx="4" data-id="element-2880" />
                  {/* Direction arrows on street */}
                  <g opacity="0.3" data-id="element-2881">
                    <path d="M 200 215 L 200 235 M 190 225 L 200 215 L 210 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2882" />
                    <path d="M 500 215 L 500 235 M 490 225 L 500 215 L 510 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2883" />
                    <path d="M 800 215 L 800 235 M 790 225 L 800 215 L 810 225" stroke="#fff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-2884" />
                  </g>
                  {/* Stores */}
                  {stores.map((store, idx) => {
                const category = categories[store.category as keyof typeof categories];
                return <g key={idx} data-id="element-2885">
                        {/* Store rectangle */}
                        <rect x={store.x} y={store.y} width={store.width} height={store.height} fill={category.color} stroke={store.isTarget ? '#1388ad' : '#495057'} strokeWidth={store.isTarget ? '4' : '2'} rx="4" data-id="element-2886" />
                        {/* Store number badge */}
                        <rect x={store.x + 5} y={store.y + 5} width="35" height="18" fill="white" stroke="#495057" strokeWidth="1" rx="3" data-id="element-2887" />
                        <text x={store.x + 22.5} y={store.y + 17} textAnchor="middle" fontSize="10" fontWeight="700" fill="#495057" data-id="element-2888">
                          {store.number}
                        </text>
                        {/* Store name */}
                        <text x={store.x + store.width / 2} y={store.y + store.height / 2 + 5} textAnchor="middle" fontSize={store.isTarget ? '13' : '11'} fontWeight={store.isTarget ? '700' : '600'} fill={store.isTarget ? 'white' : '#212529'} data-id="element-2889">
                          {store.name.split('\n').map((line, i) => <tspan key={i} x={store.x + store.width / 2} dy={i > 0 ? '12' : '0'} data-id="element-2890">
                              {line}
                            </tspan>)}
                        </text>
                        {/* Target property indicator */}
                        {store.isTarget && <>
                            <text x={store.x + store.width / 2} y={store.y - 12} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1388ad" data-id="element-2891">
                              ★ IMMOBILE TARGET ★
                            </text>
                          </>}
                      </g>;
              })}
                  {/* Street side labels */}
                  <text x="15" y="125" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 125)" data-id="element-2892">
                    LATO NORD
                  </text>
                  <text x="15" y="335" fontSize="10" fill="#6c757d" fontWeight="600" transform="rotate(-90 15 335)" data-id="element-2893">
                    LATO SUD
                  </text>
                  {/* Legend - positioned on the right */}
                  <g transform="translate(1000, 80)" data-id="element-2894">
                    <text x="0" y="0" fontSize="11" fontWeight="700" fill="#212529" data-id="element-2895">
                      LEGENDA
                    </text>
                    {Object.entries(categories).map(([key, cat], idx) => <g key={key} transform={`translate(0, ${idx * 35 + 20})`} data-id="element-2896">
                        <rect x="0" y="-9" width="18" height="13" fill={cat.color} stroke="#495057" strokeWidth="1" rx="2" data-id="element-2897" />
                        <text x="23" y="0" fontSize="9" fill="#495057" data-id="element-2898">
                          {cat.label}
                        </text>
                      </g>)}
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}